/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAuthData
// ====================================================

export interface GetAuthData_me_principal_user {
  __typename: "User";
  id: string;
  fullName: string | null;
  hasGivenConsentForProgression: boolean;
  hasGivenConsentForScores: boolean;
}

export interface GetAuthData_me_principal {
  __typename: "MePrincipal";
  user: GetAuthData_me_principal_user;
}

export interface GetAuthData_me_menu {
  __typename: "MeMenu";
  admin: boolean;
  feedback: boolean;
  graphiql: boolean;
  studies: boolean;
  teacherFeedback: boolean;
}

export interface GetAuthData_me {
  __typename: "Me";
  /**
   * If this is null no valid authorization token was found.
   */
  principal: GetAuthData_me_principal | null;
  menu: GetAuthData_me_menu;
}

export interface GetAuthData {
  me: GetAuthData_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BackendSignOut
// ====================================================

export interface BackendSignOut_backendSignOut {
  __typename: "SignOutPayload";
  success: boolean;
}

export interface BackendSignOut {
  backendSignOut: BackendSignOut_backendSignOut | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendChatMessage
// ====================================================

export interface SendChatMessage {
  sendChatMessage: boolean;
}

export interface SendChatMessageVariables {
  input: ChatRequestMessageInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: OnChatSubscription
// ====================================================

export interface OnChatSubscription_chatSubscription_role {
  __typename: "ChatRole";
  name: string | null;
}

export interface OnChatSubscription_chatSubscription {
  __typename: "ChatResponseMessage";
  refusal: string | null;
  content: string | null;
  role: OnChatSubscription_chatSubscription_role | null;
}

export interface OnChatSubscription {
  chatSubscription: OnChatSubscription_chatSubscription;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMyStudyProgrammes
// ====================================================

export interface GetMyStudyProgrammes_studyProgrammeList {
  __typename: "StudyProgramme";
  title: string;
  id: string;
  status: ContentStatus;
}

export interface GetMyStudyProgrammes {
  studyProgrammeList: GetMyStudyProgrammes_studyProgrammeList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStudyProgrammeContainerContexts
// ====================================================

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement {
  __typename: "StudyProgrammeContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerArticleElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerMultipleChoiceElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_contentList[];
  type: FolderType | null;
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements {
  __typename: "ExamSyllabusContainerFolderElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content {
  __typename: "ExamSyllabusContainer";
  title: string;
  referencedContentId: string;
  contentList: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_contentList[];
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement {
  __typename: "StudyProgrammeContainerExamSyllabusElement";
  content: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content;
}

export type GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements = GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement | GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement;

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer {
  __typename: "StudyProgrammeContainer";
  status: ContentStatus;
  title: string;
  referencedContentId: string;
  elements: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer_elements[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_examSyllabusContainerContexts {
  __typename: "ContainerContext";
  path: string;
  referencedContentId: string;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_folderContainerContexts {
  __typename: "ContainerContext";
  path: string;
  referencedContentId: string;
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers {
  __typename: "StudyProgrammeWithContainers";
  studyProgrammeContainer: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_studyProgrammeContainer;
  examSyllabusContainerContexts: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_examSyllabusContainerContexts[];
  folderContainerContexts: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers_folderContainerContexts[];
}

export interface GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts {
  __typename: "GetExamSyllabusContainerContextsPayload";
  studyProgrammesWithContainers: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts_studyProgrammesWithContainers[];
}

export interface GetStudyProgrammeContainerContexts {
  getStudyProgrammeContainerContexts: GetStudyProgrammeContainerContexts_getStudyProgrammeContainerContexts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMyExams
// ====================================================

export interface GetMyExams_examSyllabusList {
  __typename: "ExamSyllabus";
  title: string;
  id: string;
}

export interface GetMyExams {
  examSyllabusList: GetMyExams_examSyllabusList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveExamSyllabiForUser
// ====================================================

export interface SaveExamSyllabiForUser_saveExamSyllabiForUser_examSyllabi {
  __typename: "ExamSyllabus";
  title: string;
  id: string;
}

export interface SaveExamSyllabiForUser_saveExamSyllabiForUser {
  __typename: "SaveExamSyllabiForUserPayload";
  examSyllabi: SaveExamSyllabiForUser_saveExamSyllabiForUser_examSyllabi[];
}

export interface SaveExamSyllabiForUser {
  saveExamSyllabiForUser: SaveExamSyllabiForUser_saveExamSyllabiForUser;
}

export interface SaveExamSyllabiForUserVariables {
  input: SaveExamSyllabiForUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveFromS3
// ====================================================

export interface RemoveFromS3_removeFromBucket {
  __typename: "RemoveFromS3Payload";
  success: boolean;
}

export interface RemoveFromS3 {
  removeFromBucket: RemoveFromS3_removeFromBucket;
}

export interface RemoveFromS3Variables {
  input: RemoveFromS3Input;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateUploadURL
// ====================================================

export interface GenerateUploadURL_generateUploadURL {
  __typename: "GenerateUploadURLPayload";
  uploadURL: string;
}

export interface GenerateUploadURL {
  generateUploadURL: GenerateUploadURL_generateUploadURL;
}

export interface GenerateUploadURLVariables {
  input: GenerateUploadURLInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateArticle
// ====================================================

export interface UpdateArticle_updateArticleDetails_article_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface UpdateArticle_updateArticleDetails_article_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface UpdateArticle_updateArticleDetails_article {
  __typename: "Article";
  id: string;
  title: string;
  body: UpdateArticle_updateArticleDetails_article_body | null;
  relevantContent: UpdateArticle_updateArticleDetails_article_relevantContent | null;
  youtubeVideoId: string | null;
}

export interface UpdateArticle_updateArticleDetails {
  __typename: "UpdateArticleDetailsPayload";
  article: UpdateArticle_updateArticleDetails_article;
}

export interface UpdateArticle {
  updateArticleDetails: UpdateArticle_updateArticleDetails;
}

export interface UpdateArticleVariables {
  input: UpdateArticleDetailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateArticleInFolder
// ====================================================

export interface CreateArticleInFolder_createArticleInFolder_folderArticle {
  __typename: "FolderElement";
  id: string;
}

export interface CreateArticleInFolder_createArticleInFolder {
  __typename: "CreateArticleInFolderPayload";
  folderArticle: CreateArticleInFolder_createArticleInFolder_folderArticle;
}

export interface CreateArticleInFolder {
  createArticleInFolder: CreateArticleInFolder_createArticleInFolder;
}

export interface CreateArticleInFolderVariables {
  input: CreateArticleInFolderInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateArticleInKurssloeyfe
// ====================================================

export interface CreateArticleInKurssloeyfe_createArticleInKurssloeyfe_kurssloeyfeArticle {
  __typename: "KurssloeyfeElement";
  id: string;
}

export interface CreateArticleInKurssloeyfe_createArticleInKurssloeyfe {
  __typename: "CreateArticleInKurssloeyfePayload";
  kurssloeyfeArticle: CreateArticleInKurssloeyfe_createArticleInKurssloeyfe_kurssloeyfeArticle;
}

export interface CreateArticleInKurssloeyfe {
  createArticleInKurssloeyfe: CreateArticleInKurssloeyfe_createArticleInKurssloeyfe;
}

export interface CreateArticleInKurssloeyfeVariables {
  input: CreateArticleInKurssloeyfeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PublishAllContentInFolder
// ====================================================

export interface PublishAllContentInFolder_publishAllContentInFolder_folder {
  __typename: "Folder";
  id: string;
}

export interface PublishAllContentInFolder_publishAllContentInFolder {
  __typename: "PublishAllContentInFolderPayload";
  folder: PublishAllContentInFolder_publishAllContentInFolder_folder;
}

export interface PublishAllContentInFolder {
  publishAllContentInFolder: PublishAllContentInFolder_publishAllContentInFolder;
}

export interface PublishAllContentInFolderVariables {
  input: PublishAllContentInFolderInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PublishAllContentInKurssloeyfe
// ====================================================

export interface PublishAllContentInKurssloeyfe_publishAllContentInKurssloeyfe_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
}

export interface PublishAllContentInKurssloeyfe_publishAllContentInKurssloeyfe {
  __typename: "PublishAllContentInKurssloeyfePayload";
  kurssloeyfe: PublishAllContentInKurssloeyfe_publishAllContentInKurssloeyfe_kurssloeyfe;
}

export interface PublishAllContentInKurssloeyfe {
  publishAllContentInKurssloeyfe: PublishAllContentInKurssloeyfe_publishAllContentInKurssloeyfe;
}

export interface PublishAllContentInKurssloeyfeVariables {
  input: PublishAllContentInKurssloeyfeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CopyContent
// ====================================================

export interface CopyContent_copyContent {
  __typename: "CopyContentPayload";
  successForContainerIds: string[];
  failForContainerIds: string[];
}

export interface CopyContent {
  copyContent: CopyContent_copyContent;
}

export interface CopyContentVariables {
  input: CopyContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MoveContent
// ====================================================

export interface MoveContent_moveContent {
  __typename: "MoveContentPayload";
  containerId: string;
}

export interface MoveContent {
  moveContent: MoveContent_moveContent;
}

export interface MoveContentVariables {
  input: MoveContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateExamSyllabus
// ====================================================

export interface CreateExamSyllabus_createExamSyllabus_examSyllabus_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface CreateExamSyllabus_createExamSyllabus_examSyllabus {
  __typename: "ExamSyllabus";
  id: string;
  title: string;
  description: CreateExamSyllabus_createExamSyllabus_examSyllabus_description | null;
}

export interface CreateExamSyllabus_createExamSyllabus {
  __typename: "CreateExamSyllabusPayload";
  examSyllabus: CreateExamSyllabus_createExamSyllabus_examSyllabus;
}

export interface CreateExamSyllabus {
  createExamSyllabus: CreateExamSyllabus_createExamSyllabus;
}

export interface CreateExamSyllabusVariables {
  input: CreateExamSyllabusInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CopyFolderToExam
// ====================================================

export interface CopyFolderToExam_addFolderToExamSyllabus_examSyllabus {
  __typename: "ExamSyllabus";
  examDate: LocalDate | null;
  title: string;
  status: ContentStatus;
}

export interface CopyFolderToExam_addFolderToExamSyllabus {
  __typename: "AddFolderToExamSyllabusPayload";
  examSyllabus: CopyFolderToExam_addFolderToExamSyllabus_examSyllabus;
}

export interface CopyFolderToExam {
  addFolderToExamSyllabus: CopyFolderToExam_addFolderToExamSyllabus;
}

export interface CopyFolderToExamVariables {
  input: AddFolderToExamSyllabusInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetParentStudyProgramme
// ====================================================

export interface GetParentStudyProgramme_studyProgrammeById_folderElements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
  status: ContentStatus;
}

export interface GetParentStudyProgramme_studyProgrammeById_folderElements {
  __typename: "StudyProgrammeElement";
  id: string;
  content: GetParentStudyProgramme_studyProgrammeById_folderElements_content;
}

export interface GetParentStudyProgramme_studyProgrammeById {
  __typename: "StudyProgramme";
  id: string;
  title: string;
  folderElements: GetParentStudyProgramme_studyProgrammeById_folderElements[];
}

export interface GetParentStudyProgramme {
  /**
   * StudyProgramme
   */
  studyProgrammeById: GetParentStudyProgramme_studyProgrammeById;
}

export interface GetParentStudyProgrammeVariables {
  studyProgrammeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateFolder
// ====================================================

export interface CreateFolder_createFolder_folder_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface CreateFolder_createFolder_folder {
  __typename: "Folder";
  id: string;
  title: string;
  description: CreateFolder_createFolder_folder_description | null;
}

export interface CreateFolder_createFolder {
  __typename: "CreateFolderPayload";
  folder: CreateFolder_createFolder_folder;
}

export interface CreateFolder {
  createFolder: CreateFolder_createFolder;
}

export interface CreateFolderVariables {
  input: CreateFolderInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateKurssloeyfeInFolder
// ====================================================

export interface CreateKurssloeyfeInFolder_createKurssloeyfeInFolder_folderKurssloeyfe {
  __typename: "FolderElement";
  id: string;
}

export interface CreateKurssloeyfeInFolder_createKurssloeyfeInFolder {
  __typename: "CreateKurssloeyfeInFolderPayload";
  folderKurssloeyfe: CreateKurssloeyfeInFolder_createKurssloeyfeInFolder_folderKurssloeyfe;
}

export interface CreateKurssloeyfeInFolder {
  createKurssloeyfeInFolder: CreateKurssloeyfeInFolder_createKurssloeyfeInFolder;
}

export interface CreateKurssloeyfeInFolderVariables {
  input: CreateKurssloeyfeInFolderInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMultipleChoiceQuestionOptions
// ====================================================

export interface CreateMultipleChoiceQuestionOptions_createMultipleChoiceQuestionOptions_options {
  __typename: "MultipleChoiceQuestionOption";
  title: string;
  id: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface CreateMultipleChoiceQuestionOptions_createMultipleChoiceQuestionOptions {
  __typename: "CreateMultipleChoiceQuestionOptionsPayload";
  options: (CreateMultipleChoiceQuestionOptions_createMultipleChoiceQuestionOptions_options | null)[];
}

export interface CreateMultipleChoiceQuestionOptions {
  createMultipleChoiceQuestionOptions: CreateMultipleChoiceQuestionOptions_createMultipleChoiceQuestionOptions;
}

export interface CreateMultipleChoiceQuestionOptionsVariables {
  input: CreateMultipleChoiceQuestionOptionsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMultipleChoiceInFolder
// ====================================================

export interface CreateMultipleChoiceInFolder_createMultipleChoiceInFolder_folderMultipleChoice {
  __typename: "FolderElement";
  id: string;
}

export interface CreateMultipleChoiceInFolder_createMultipleChoiceInFolder {
  __typename: "CreateMultipleChoiceInFolderPayload";
  folderMultipleChoice: CreateMultipleChoiceInFolder_createMultipleChoiceInFolder_folderMultipleChoice | null;
}

export interface CreateMultipleChoiceInFolder {
  createMultipleChoiceInFolder: CreateMultipleChoiceInFolder_createMultipleChoiceInFolder;
}

export interface CreateMultipleChoiceInFolderVariables {
  input: CreateMultipleChoiceInFolderInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMultipleChoiceInKurssloeyfe
// ====================================================

export interface CreateMultipleChoiceInKurssloeyfe_createMultipleChoiceInKurssloeyfe_kurssloeyfeMultipleChoice {
  __typename: "KurssloeyfeElement";
  id: string;
}

export interface CreateMultipleChoiceInKurssloeyfe_createMultipleChoiceInKurssloeyfe {
  __typename: "CreateMultipleChoiceInKurssloeyfePayload";
  kurssloeyfeMultipleChoice: CreateMultipleChoiceInKurssloeyfe_createMultipleChoiceInKurssloeyfe_kurssloeyfeMultipleChoice | null;
}

export interface CreateMultipleChoiceInKurssloeyfe {
  createMultipleChoiceInKurssloeyfe: CreateMultipleChoiceInKurssloeyfe_createMultipleChoiceInKurssloeyfe;
}

export interface CreateMultipleChoiceInKurssloeyfeVariables {
  input: CreateMultipleChoiceInKurssloeyfeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMultipleChoiceQuestion
// ====================================================

export interface CreateMultipleChoiceQuestion_createMultipleChoiceQuestion_multipleChoiceQuestion_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface CreateMultipleChoiceQuestion_createMultipleChoiceQuestion_multipleChoiceQuestion_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface CreateMultipleChoiceQuestion_createMultipleChoiceQuestion_multipleChoiceQuestion {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: CreateMultipleChoiceQuestion_createMultipleChoiceQuestion_multipleChoiceQuestion_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: CreateMultipleChoiceQuestion_createMultipleChoiceQuestion_multipleChoiceQuestion_options[] | null;
}

export interface CreateMultipleChoiceQuestion_createMultipleChoiceQuestion {
  __typename: "CreateMultipleChoiceQuestionPayload";
  multipleChoiceQuestion: CreateMultipleChoiceQuestion_createMultipleChoiceQuestion_multipleChoiceQuestion;
}

export interface CreateMultipleChoiceQuestion {
  createMultipleChoiceQuestion: CreateMultipleChoiceQuestion_createMultipleChoiceQuestion;
}

export interface CreateMultipleChoiceQuestionVariables {
  input: CreateMultipleChoiceQuestionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReorderMultipleChoiceQuestionOption
// ====================================================

export interface ReorderMultipleChoiceQuestionOption_reorderMultipleChoiceQuestionOption_option {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
}

export interface ReorderMultipleChoiceQuestionOption_reorderMultipleChoiceQuestionOption {
  __typename: "ReorderMultipleChoiceQuestionOptionPayload";
  option: ReorderMultipleChoiceQuestionOption_reorderMultipleChoiceQuestionOption_option;
}

export interface ReorderMultipleChoiceQuestionOption {
  reorderMultipleChoiceQuestionOption: ReorderMultipleChoiceQuestionOption_reorderMultipleChoiceQuestionOption;
}

export interface ReorderMultipleChoiceQuestionOptionVariables {
  input: ReorderMultipleChoiceQuestionOptionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMultipleChoiceQuestionDetails
// ====================================================

export interface UpdateMultipleChoiceQuestionDetails_updateMultipleChoiceQuestionDetails_multipleChoiceQuestion {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
}

export interface UpdateMultipleChoiceQuestionDetails_updateMultipleChoiceQuestionDetails {
  __typename: "UpdateMultipleChoiceQuestionDetailsPayload";
  multipleChoiceQuestion: UpdateMultipleChoiceQuestionDetails_updateMultipleChoiceQuestionDetails_multipleChoiceQuestion;
}

export interface UpdateMultipleChoiceQuestionDetails {
  updateMultipleChoiceQuestionDetails: UpdateMultipleChoiceQuestionDetails_updateMultipleChoiceQuestionDetails;
}

export interface UpdateMultipleChoiceQuestionDetailsVariables {
  input: UpdateMultipleChoiceQuestionDetailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteMultipleChoiceQuestion
// ====================================================

export interface DeleteMultipleChoiceQuestion_deleteMultipleChoiceQuestion_multipleChoice {
  __typename: "MultipleChoice";
  id: string;
  title: string;
}

export interface DeleteMultipleChoiceQuestion_deleteMultipleChoiceQuestion {
  __typename: "DeleteMultipleChoiceQuestionPayload";
  multipleChoice: DeleteMultipleChoiceQuestion_deleteMultipleChoiceQuestion_multipleChoice;
}

export interface DeleteMultipleChoiceQuestion {
  deleteMultipleChoiceQuestion: DeleteMultipleChoiceQuestion_deleteMultipleChoiceQuestion;
}

export interface DeleteMultipleChoiceQuestionVariables {
  input: DeleteMultipleChoiceQuestionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMultipleChoiceQuestionOption
// ====================================================

export interface UpdateMultipleChoiceQuestionOption_updateMultipleChoiceQuestionOption_option {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface UpdateMultipleChoiceQuestionOption_updateMultipleChoiceQuestionOption {
  __typename: "UpdateMultipleChoiceQuestionOptionPayload";
  option: UpdateMultipleChoiceQuestionOption_updateMultipleChoiceQuestionOption_option;
}

export interface UpdateMultipleChoiceQuestionOption {
  updateMultipleChoiceQuestionOption: UpdateMultipleChoiceQuestionOption_updateMultipleChoiceQuestionOption;
}

export interface UpdateMultipleChoiceQuestionOptionVariables {
  input: UpdateMultipleChoiceQuestionOptionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteMultipleChoiceQuestionOption
// ====================================================

export interface DeleteMultipleChoiceQuestionOption_deleteMultipleChoiceQuestionOption_question {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
}

export interface DeleteMultipleChoiceQuestionOption_deleteMultipleChoiceQuestionOption {
  __typename: "DeleteMultipleChoiceQuestionOptionPayload";
  question: DeleteMultipleChoiceQuestionOption_deleteMultipleChoiceQuestionOption_question;
}

export interface DeleteMultipleChoiceQuestionOption {
  deleteMultipleChoiceQuestionOption: DeleteMultipleChoiceQuestionOption_deleteMultipleChoiceQuestionOption;
}

export interface DeleteMultipleChoiceQuestionOptionVariables {
  input: DeleteMultipleChoiceQuestionOptionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStudyProgrammesAdministration
// ====================================================

export interface GetStudyProgrammesAdministration_studyProgrammeList {
  __typename: "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetStudyProgrammesAdministration {
  studyProgrammeList: GetStudyProgrammesAdministration_studyProgrammeList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ArticleAdminPageData
// ====================================================

export interface ArticleAdminPageData_articleById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ArticleAdminPageData_articleById_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface ArticleAdminPageData_articleById_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface ArticleAdminPageData_articleById {
  __typename: "Article";
  id: string;
  title: string;
  status: ContentStatus;
  context: ArticleAdminPageData_articleById_context[];
  youtubeVideoId: string | null;
  body: ArticleAdminPageData_articleById_body | null;
  relevantContent: ArticleAdminPageData_articleById_relevantContent | null;
}

export interface ArticleAdminPageData {
  articleById: ArticleAdminPageData_articleById | null;
}

export interface ArticleAdminPageDataVariables {
  articleId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ExamEditPageData
// ====================================================

export interface ExamEditPageData_examSyllabusById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface ExamEditPageData_examSyllabusById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamEditPageData_examSyllabusById {
  __typename: "ExamSyllabus";
  examDate: LocalDate | null;
  description: ExamEditPageData_examSyllabusById_description | null;
  id: string;
  title: string;
  studyPoints: number;
  status: ContentStatus;
  context: ExamEditPageData_examSyllabusById_context[];
}

export interface ExamEditPageData {
  /**
   * ExamSyllabus
   */
  examSyllabusById: ExamEditPageData_examSyllabusById | null;
}

export interface ExamEditPageDataVariables {
  examId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ExamSyllabusFolderOptions
// ====================================================

export interface ExamSyllabusFolderOptions_folderList {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface ExamSyllabusFolderOptions {
  folderList: ExamSyllabusFolderOptions_folderList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateExam
// ====================================================

export interface UpdateExam_updateExamSyllabusDetails_examSyllabus_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface UpdateExam_updateExamSyllabusDetails_examSyllabus {
  __typename: "ExamSyllabus";
  examDate: LocalDate | null;
  description: UpdateExam_updateExamSyllabusDetails_examSyllabus_description | null;
  id: string;
  title: string;
  studyPoints: number;
  status: ContentStatus;
}

export interface UpdateExam_updateExamSyllabusDetails {
  __typename: "UpdateExamSyllabusDetailsPayload";
  examSyllabus: UpdateExam_updateExamSyllabusDetails_examSyllabus;
}

export interface UpdateExam {
  updateExamSyllabusDetails: UpdateExam_updateExamSyllabusDetails;
}

export interface UpdateExamVariables {
  input: UpdateExamSyllabusDetailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ExamSyllabusAdminPageData
// ====================================================

export interface ExamSyllabusAdminPageData_examSyllabusById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamSyllabusAdminPageData_examSyllabusById_elements_content_Article {
  __typename: "Article" | "ExamSyllabus" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface ExamSyllabusAdminPageData_examSyllabusById_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type ExamSyllabusAdminPageData_examSyllabusById_elements_content = ExamSyllabusAdminPageData_examSyllabusById_elements_content_Article | ExamSyllabusAdminPageData_examSyllabusById_elements_content_Folder;

export interface ExamSyllabusAdminPageData_examSyllabusById_elements {
  __typename: "ExamSyllabusElement";
  id: string;
  content: ExamSyllabusAdminPageData_examSyllabusById_elements_content;
}

export interface ExamSyllabusAdminPageData_examSyllabusById {
  __typename: "ExamSyllabus";
  status: ContentStatus;
  id: string;
  title: string;
  context: ExamSyllabusAdminPageData_examSyllabusById_context[];
  elements: ExamSyllabusAdminPageData_examSyllabusById_elements[];
}

export interface ExamSyllabusAdminPageData {
  /**
   * ExamSyllabus
   */
  examSyllabusById: ExamSyllabusAdminPageData_examSyllabusById | null;
}

export interface ExamSyllabusAdminPageDataVariables {
  examId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReorderExamSyllabusElement
// ====================================================

export interface ReorderExamSyllabusElement_reorderExamSyllabusElement_examSyllabus {
  __typename: "ExamSyllabus";
  id: string;
}

export interface ReorderExamSyllabusElement_reorderExamSyllabusElement {
  __typename: "ReorderExamSyllabusElementPayload";
  examSyllabus: ReorderExamSyllabusElement_reorderExamSyllabusElement_examSyllabus;
}

export interface ReorderExamSyllabusElement {
  reorderExamSyllabusElement: ReorderExamSyllabusElement_reorderExamSyllabusElement;
}

export interface ReorderExamSyllabusElementVariables {
  input: ReorderExamSyllabusElementInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FolderAdminPageData
// ====================================================

export interface FolderAdminPageData_folderById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface FolderAdminPageData_folderById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface FolderAdminPageData_folderById_elements_content_Article {
  __typename: "Article" | "ExamSyllabus" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface FolderAdminPageData_folderById_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type FolderAdminPageData_folderById_elements_content = FolderAdminPageData_folderById_elements_content_Article | FolderAdminPageData_folderById_elements_content_Folder;

export interface FolderAdminPageData_folderById_elements {
  __typename: "FolderElement";
  id: string;
  content: FolderAdminPageData_folderById_elements_content;
}

export interface FolderAdminPageData_folderById {
  __typename: "Folder";
  id: string;
  title: string;
  status: ContentStatus;
  context: FolderAdminPageData_folderById_context[];
  type: FolderType;
  description: FolderAdminPageData_folderById_description | null;
  elements: FolderAdminPageData_folderById_elements[];
}

export interface FolderAdminPageData {
  folderById: FolderAdminPageData_folderById | null;
}

export interface FolderAdminPageDataVariables {
  folderId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReorderFolderElement
// ====================================================

export interface ReorderFolderElement_reorderFolderElement_folder {
  __typename: "Folder";
  id: string;
}

export interface ReorderFolderElement_reorderFolderElement {
  __typename: "ReorderFolderElementPayload";
  folder: ReorderFolderElement_reorderFolderElement_folder;
}

export interface ReorderFolderElement {
  reorderFolderElement: ReorderFolderElement_reorderFolderElement;
}

export interface ReorderFolderElementVariables {
  input: ReorderFolderElementInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FolderEditPageData
// ====================================================

export interface FolderEditPageData_folderById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface FolderEditPageData_folderById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface FolderEditPageData_folderById {
  __typename: "Folder";
  id: string;
  title: string;
  status: ContentStatus;
  context: FolderEditPageData_folderById_context[];
  type: FolderType;
  description: FolderEditPageData_folderById_description | null;
}

export interface FolderEditPageData {
  folderById: FolderEditPageData_folderById | null;
}

export interface FolderEditPageDataVariables {
  folderId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFolder
// ====================================================

export interface UpdateFolder_updateFolderDetails_folder_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface UpdateFolder_updateFolderDetails_folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  description: UpdateFolder_updateFolderDetails_folder_description | null;
}

export interface UpdateFolder_updateFolderDetails {
  __typename: "UpdateFolderDetailsPayload";
  folder: UpdateFolder_updateFolderDetails_folder;
}

export interface UpdateFolder {
  updateFolderDetails: UpdateFolder_updateFolderDetails;
}

export interface UpdateFolderVariables {
  input: UpdateFolderDetailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: KurssloeyfeAdminPageData
// ====================================================

export interface KurssloeyfeAdminPageData_kurssloeyfeById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface KurssloeyfeAdminPageData_kurssloeyfeById_elements_parent {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface KurssloeyfeAdminPageData_kurssloeyfeById_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface KurssloeyfeAdminPageData_kurssloeyfeById_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export type KurssloeyfeAdminPageData_kurssloeyfeById_elements_content = KurssloeyfeAdminPageData_kurssloeyfeById_elements_content_ExamSyllabus | KurssloeyfeAdminPageData_kurssloeyfeById_elements_content_Article;

export interface KurssloeyfeAdminPageData_kurssloeyfeById_elements {
  __typename: "KurssloeyfeElement";
  parent: KurssloeyfeAdminPageData_kurssloeyfeById_elements_parent;
  id: string;
  content: KurssloeyfeAdminPageData_kurssloeyfeById_elements_content;
}

export interface KurssloeyfeAdminPageData_kurssloeyfeById {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
  status: ContentStatus;
  context: KurssloeyfeAdminPageData_kurssloeyfeById_context[];
  elements: KurssloeyfeAdminPageData_kurssloeyfeById_elements[];
}

export interface KurssloeyfeAdminPageData {
  kurssloeyfeById: KurssloeyfeAdminPageData_kurssloeyfeById | null;
}

export interface KurssloeyfeAdminPageDataVariables {
  kurssloeyfeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReorderKurssloeyfeElement
// ====================================================

export interface ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements_content_Article {
  __typename: "Article";
  id: string;
  title: string;
  youtubeVideoId: string | null;
}

export type ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements_content = ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements_content_ExamSyllabus | ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements_content_Article;

export interface ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements {
  __typename: "KurssloeyfeElement";
  id: string;
  content: ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements_content;
}

export interface ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe {
  __typename: "Kurssloeyfe";
  elements: ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe_elements[];
}

export interface ReorderKurssloeyfeElement_reorderKurssloeyfeElement {
  __typename: "ReorderKurssloeyfeElementPayload";
  kurssloeyfe: ReorderKurssloeyfeElement_reorderKurssloeyfeElement_kurssloeyfe;
}

export interface ReorderKurssloeyfeElement {
  reorderKurssloeyfeElement: ReorderKurssloeyfeElement_reorderKurssloeyfeElement;
}

export interface ReorderKurssloeyfeElementVariables {
  input: ReorderKurssloeyfeElementInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: KurssloeyfeEditData
// ====================================================

export interface KurssloeyfeEditData_kurssloeyfeById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface KurssloeyfeEditData_kurssloeyfeById {
  __typename: "Kurssloeyfe";
  id: string;
  status: ContentStatus;
  title: string;
  context: KurssloeyfeEditData_kurssloeyfeById_context[];
}

export interface KurssloeyfeEditData {
  kurssloeyfeById: KurssloeyfeEditData_kurssloeyfeById | null;
}

export interface KurssloeyfeEditDataVariables {
  kurssloeyfeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateKurssloeyfe
// ====================================================

export interface UpdateKurssloeyfe_updateKurssloeyfeDetails_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
}

export interface UpdateKurssloeyfe_updateKurssloeyfeDetails {
  __typename: "UpdateKurssloeyfeDetailsPayload";
  kurssloeyfe: UpdateKurssloeyfe_updateKurssloeyfeDetails_kurssloeyfe;
}

export interface UpdateKurssloeyfe {
  updateKurssloeyfeDetails: UpdateKurssloeyfe_updateKurssloeyfeDetails;
}

export interface UpdateKurssloeyfeVariables {
  input: UpdateKurssloeyfeDetailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReorderMultipleChoiceQuestion
// ====================================================

export interface ReorderMultipleChoiceQuestion_reorderMultipleChoiceQuestion_question {
  __typename: "MultipleChoiceQuestion";
  id: string;
}

export interface ReorderMultipleChoiceQuestion_reorderMultipleChoiceQuestion {
  __typename: "ReorderMultipleChoiceQuestionPayload";
  question: ReorderMultipleChoiceQuestion_reorderMultipleChoiceQuestion_question;
}

export interface ReorderMultipleChoiceQuestion {
  reorderMultipleChoiceQuestion: ReorderMultipleChoiceQuestion_reorderMultipleChoiceQuestion;
}

export interface ReorderMultipleChoiceQuestionVariables {
  input: ReorderMultipleChoiceQuestionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MultipleChoiceAdminPageData
// ====================================================

export interface MultipleChoiceAdminPageData_multipleChoiceById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface MultipleChoiceAdminPageData_multipleChoiceById_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceAdminPageData_multipleChoiceById_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceAdminPageData_multipleChoiceById_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceAdminPageData_multipleChoiceById_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface MultipleChoiceAdminPageData_multipleChoiceById_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: MultipleChoiceAdminPageData_multipleChoiceById_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: MultipleChoiceAdminPageData_multipleChoiceById_questions_options[] | null;
}

export interface MultipleChoiceAdminPageData_multipleChoiceById {
  __typename: "MultipleChoice";
  id: string;
  title: string;
  status: ContentStatus;
  context: MultipleChoiceAdminPageData_multipleChoiceById_context[];
  type: MultipleChoiceType;
  ingress: MultipleChoiceAdminPageData_multipleChoiceById_ingress | null;
  relevantContent: MultipleChoiceAdminPageData_multipleChoiceById_relevantContent | null;
  questions: MultipleChoiceAdminPageData_multipleChoiceById_questions[];
}

export interface MultipleChoiceAdminPageData {
  multipleChoiceById: MultipleChoiceAdminPageData_multipleChoiceById | null;
}

export interface MultipleChoiceAdminPageDataVariables {
  multipleChoiceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MultipleChoiceEditData
// ====================================================

export interface MultipleChoiceEditData_multipleChoiceById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface MultipleChoiceEditData_multipleChoiceById_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceEditData_multipleChoiceById_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceEditData_multipleChoiceById_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceEditData_multipleChoiceById_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface MultipleChoiceEditData_multipleChoiceById_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: MultipleChoiceEditData_multipleChoiceById_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: MultipleChoiceEditData_multipleChoiceById_questions_options[] | null;
}

export interface MultipleChoiceEditData_multipleChoiceById {
  __typename: "MultipleChoice";
  id: string;
  type: MultipleChoiceType;
  status: ContentStatus;
  title: string;
  context: MultipleChoiceEditData_multipleChoiceById_context[];
  ingress: MultipleChoiceEditData_multipleChoiceById_ingress | null;
  relevantContent: MultipleChoiceEditData_multipleChoiceById_relevantContent | null;
  questions: MultipleChoiceEditData_multipleChoiceById_questions[];
}

export interface MultipleChoiceEditData {
  multipleChoiceById: MultipleChoiceEditData_multipleChoiceById | null;
}

export interface MultipleChoiceEditDataVariables {
  multipleChoiceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMultipleChoiceDetails
// ====================================================

export interface UpdateMultipleChoiceDetails_updateMultipleChoiceDetails_multipleChoice {
  __typename: "MultipleChoice";
  id: string;
}

export interface UpdateMultipleChoiceDetails_updateMultipleChoiceDetails {
  __typename: "UpdateMultipleChoiceDetailsPayload";
  multipleChoice: UpdateMultipleChoiceDetails_updateMultipleChoiceDetails_multipleChoice;
}

export interface UpdateMultipleChoiceDetails {
  updateMultipleChoiceDetails: UpdateMultipleChoiceDetails_updateMultipleChoiceDetails;
}

export interface UpdateMultipleChoiceDetailsVariables {
  input: UpdateMultipleChoiceDetailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SimulationCaseListFragment
// ====================================================

export interface SimulationCaseListFragment_simulationCaseList {
  __typename: "SimulationCase";
  id: string;
  title: string;
  status: ContentStatus | null;
}

export interface SimulationCaseListFragment {
  simulationCaseList: SimulationCaseListFragment_simulationCaseList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StudyProgrammeAdminPageData
// ====================================================

export interface StudyProgrammeAdminPageData_studyProgrammeById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface StudyProgrammeAdminPageData_studyProgrammeById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface StudyProgrammeAdminPageData_studyProgrammeById_elements_content_Article {
  __typename: "Article" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface StudyProgrammeAdminPageData_studyProgrammeById_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface StudyProgrammeAdminPageData_studyProgrammeById_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus";
  id: string;
  status: ContentStatus;
  title: string;
  context: StudyProgrammeAdminPageData_studyProgrammeById_elements_content_ExamSyllabus_context[];
}

export interface StudyProgrammeAdminPageData_studyProgrammeById_elements_content_Folder_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface StudyProgrammeAdminPageData_studyProgrammeById_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  context: StudyProgrammeAdminPageData_studyProgrammeById_elements_content_Folder_context[];
}

export type StudyProgrammeAdminPageData_studyProgrammeById_elements_content = StudyProgrammeAdminPageData_studyProgrammeById_elements_content_Article | StudyProgrammeAdminPageData_studyProgrammeById_elements_content_ExamSyllabus | StudyProgrammeAdminPageData_studyProgrammeById_elements_content_Folder;

export interface StudyProgrammeAdminPageData_studyProgrammeById_elements {
  __typename: "StudyProgrammeElement";
  id: string;
  content: StudyProgrammeAdminPageData_studyProgrammeById_elements_content;
}

export interface StudyProgrammeAdminPageData_studyProgrammeById {
  __typename: "StudyProgramme";
  id: string;
  title: string;
  status: ContentStatus;
  context: StudyProgrammeAdminPageData_studyProgrammeById_context[];
  description: StudyProgrammeAdminPageData_studyProgrammeById_description;
  elements: StudyProgrammeAdminPageData_studyProgrammeById_elements[];
}

export interface StudyProgrammeAdminPageData {
  /**
   * StudyProgramme
   */
  studyProgrammeById: StudyProgrammeAdminPageData_studyProgrammeById;
}

export interface StudyProgrammeAdminPageDataVariables {
  studyProgrammeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReorderStudyProgrammeElement
// ====================================================

export interface ReorderStudyProgrammeElement_reorderStudyProgrammeElement_studyProgramme {
  __typename: "StudyProgramme";
  id: string;
}

export interface ReorderStudyProgrammeElement_reorderStudyProgrammeElement {
  __typename: "ReorderStudyProgrammeElementPayload";
  studyProgramme: ReorderStudyProgrammeElement_reorderStudyProgrammeElement_studyProgramme;
}

export interface ReorderStudyProgrammeElement {
  reorderStudyProgrammeElement: ReorderStudyProgrammeElement_reorderStudyProgrammeElement;
}

export interface ReorderStudyProgrammeElementVariables {
  input: ReorderStudyProgrammeElementInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StudyProgrammeEditPageData
// ====================================================

export interface StudyProgrammeEditPageData_studyProgrammeById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface StudyProgrammeEditPageData_studyProgrammeById_elements_content_Article {
  __typename: "Article" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface StudyProgrammeEditPageData_studyProgrammeById_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface StudyProgrammeEditPageData_studyProgrammeById_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus";
  id: string;
  status: ContentStatus;
  title: string;
  context: StudyProgrammeEditPageData_studyProgrammeById_elements_content_ExamSyllabus_context[];
}

export interface StudyProgrammeEditPageData_studyProgrammeById_elements_content_Folder_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface StudyProgrammeEditPageData_studyProgrammeById_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  context: StudyProgrammeEditPageData_studyProgrammeById_elements_content_Folder_context[];
}

export type StudyProgrammeEditPageData_studyProgrammeById_elements_content = StudyProgrammeEditPageData_studyProgrammeById_elements_content_Article | StudyProgrammeEditPageData_studyProgrammeById_elements_content_ExamSyllabus | StudyProgrammeEditPageData_studyProgrammeById_elements_content_Folder;

export interface StudyProgrammeEditPageData_studyProgrammeById_elements {
  __typename: "StudyProgrammeElement";
  id: string;
  content: StudyProgrammeEditPageData_studyProgrammeById_elements_content;
}

export interface StudyProgrammeEditPageData_studyProgrammeById {
  __typename: "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
  description: StudyProgrammeEditPageData_studyProgrammeById_description;
  elements: StudyProgrammeEditPageData_studyProgrammeById_elements[];
}

export interface StudyProgrammeEditPageData {
  /**
   * StudyProgramme
   */
  studyProgrammeById: StudyProgrammeEditPageData_studyProgrammeById;
}

export interface StudyProgrammeEditPageDataVariables {
  studyProgrammeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateStudyProgramme
// ====================================================

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_Article {
  __typename: "Article" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus";
  id: string;
  status: ContentStatus;
  title: string;
  context: UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_ExamSyllabus_context[];
}

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_Folder_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  context: UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_Folder_context[];
}

export type UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content = UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_Article | UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_ExamSyllabus | UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content_Folder;

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements {
  __typename: "StudyProgrammeElement";
  id: string;
  content: UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements_content;
}

export interface UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme {
  __typename: "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
  description: UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_description;
  elements: UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme_elements[];
}

export interface UpdateStudyProgramme_updateStudyProgrammeDetails {
  __typename: "UpdateStudyProgrammeDetailsPayload";
  studyProgramme: UpdateStudyProgramme_updateStudyProgrammeDetails_studyProgramme;
}

export interface UpdateStudyProgramme {
  updateStudyProgrammeDetails: UpdateStudyProgramme_updateStudyProgrammeDetails;
}

export interface UpdateStudyProgrammeVariables {
  input: UpdateStudyProgrammeDetailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSimulationCaseOutline
// ====================================================

export interface CreateSimulationCaseOutline_createSimulationCaseOutline_simulationCase_patientInformation {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface CreateSimulationCaseOutline_createSimulationCaseOutline_simulationCase {
  __typename: "SimulationCase";
  title: string;
  clinicalCategory: string | null;
  difficulty: string | null;
  module: string | null;
  patientInformation: CreateSimulationCaseOutline_createSimulationCaseOutline_simulationCase_patientInformation | null;
  status: ContentStatus | null;
}

export interface CreateSimulationCaseOutline_createSimulationCaseOutline {
  __typename: "CreateSimulationCasePayLoad";
  simulationCase: CreateSimulationCaseOutline_createSimulationCaseOutline_simulationCase;
}

export interface CreateSimulationCaseOutline {
  createSimulationCaseOutline: CreateSimulationCaseOutline_createSimulationCaseOutline | null;
}

export interface CreateSimulationCaseOutlineVariables {
  input: CreateSimulationCaseOutlineInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateStudyProgramme
// ====================================================

export interface CreateStudyProgramme_createStudyProgramme_studyProgramme {
  __typename: "StudyProgramme";
  id: string;
}

export interface CreateStudyProgramme_createStudyProgramme {
  __typename: "CreateStudyProgrammePayload";
  studyProgramme: CreateStudyProgramme_createStudyProgramme_studyProgramme;
}

export interface CreateStudyProgramme {
  createStudyProgramme: CreateStudyProgramme_createStudyProgramme;
}

export interface CreateStudyProgrammeVariables {
  input: CreateStudyProgrammeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConsentStatusForRedirect
// ====================================================

export interface GetConsentStatusForRedirect_consentStatusList_basis {
  __typename: "ConsentBasis";
  id: string;
  title: string;
  type: ConsentType;
  purpose: string;
  validFrom: DateTime;
}

export interface GetConsentStatusForRedirect_consentStatusList {
  __typename: "UserConsent";
  isGiven: boolean;
  completed: boolean;
  basis: GetConsentStatusForRedirect_consentStatusList_basis;
}

export interface GetConsentStatusForRedirect {
  consentStatusList: GetConsentStatusForRedirect_consentStatusList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContentStatus
// ====================================================

export interface UpdateContentStatus_updateContentStatus {
  __typename: "UpdateContentStatusPayload";
  status: ContentStatus;
}

export interface UpdateContentStatus {
  updateContentStatus: UpdateContentStatus_updateContentStatus;
}

export interface UpdateContentStatusVariables {
  input: UpdateContentStatusInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FinishContent
// ====================================================

export interface FinishContent_finishContent {
  __typename: "FinishContentPayload";
  success: boolean;
}

export interface FinishContent {
  finishContent: FinishContent_finishContent;
}

export interface FinishContentVariables {
  input: FinishContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SimulationCaseById
// ====================================================

export interface SimulationCaseById_simulationCaseById_instantReferral {
  __typename: "Referral";
  referralValue: boolean | null;
  referralContent: string | null;
}

export interface SimulationCaseById_simulationCaseById_diagnosis {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface SimulationCaseById_simulationCaseById_treatment {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface SimulationCaseById_simulationCaseById_referral {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface SimulationCaseById_simulationCaseById_patientInformation {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SimulationCaseById_simulationCaseById_assessments_testResult {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SimulationCaseById_simulationCaseById_assessments {
  __typename: "ClinicalTest";
  testName: string | null;
  testResult: SimulationCaseById_simulationCaseById_assessments_testResult | null;
}

export interface SimulationCaseById_simulationCaseById_nextCase {
  __typename: "NextCase";
  title: string | null;
  id: string | null;
}

export interface SimulationCaseById_simulationCaseById {
  __typename: "SimulationCase";
  id: string;
  title: string;
  instantReferral: SimulationCaseById_simulationCaseById_instantReferral | null;
  diagnosis: (SimulationCaseById_simulationCaseById_diagnosis | null)[] | null;
  treatment: (SimulationCaseById_simulationCaseById_treatment | null)[] | null;
  referral: (SimulationCaseById_simulationCaseById_referral | null)[] | null;
  patientInformation: SimulationCaseById_simulationCaseById_patientInformation | null;
  assessments: (SimulationCaseById_simulationCaseById_assessments | null)[] | null;
  status: ContentStatus | null;
  module: string | null;
  difficulty: string | null;
  clinicalCategory: string | null;
  nextCase: SimulationCaseById_simulationCaseById_nextCase | null;
}

export interface SimulationCaseById {
  simulationCaseById: SimulationCaseById_simulationCaseById | null;
}

export interface SimulationCaseByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSimulationCase
// ====================================================

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_instantReferral {
  __typename: "Referral";
  referralValue: boolean | null;
  referralContent: string | null;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_diagnosis {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_treatment {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_referral {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_patientInformation {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_assessments_testResult {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_assessments {
  __typename: "ClinicalTest";
  testName: string | null;
  testResult: UpdateSimulationCase_updateSimulationCase_simulationCase_assessments_testResult | null;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase_nextCase {
  __typename: "NextCase";
  title: string | null;
  id: string | null;
}

export interface UpdateSimulationCase_updateSimulationCase_simulationCase {
  __typename: "SimulationCase";
  title: string;
  instantReferral: UpdateSimulationCase_updateSimulationCase_simulationCase_instantReferral | null;
  diagnosis: (UpdateSimulationCase_updateSimulationCase_simulationCase_diagnosis | null)[] | null;
  treatment: (UpdateSimulationCase_updateSimulationCase_simulationCase_treatment | null)[] | null;
  referral: (UpdateSimulationCase_updateSimulationCase_simulationCase_referral | null)[] | null;
  patientInformation: UpdateSimulationCase_updateSimulationCase_simulationCase_patientInformation | null;
  assessments: (UpdateSimulationCase_updateSimulationCase_simulationCase_assessments | null)[] | null;
  status: ContentStatus | null;
  module: string | null;
  difficulty: string | null;
  clinicalCategory: string | null;
  nextCase: UpdateSimulationCase_updateSimulationCase_simulationCase_nextCase | null;
}

export interface UpdateSimulationCase_updateSimulationCase {
  __typename: "UpdateSimulationCasePayLoad";
  simulationCase: UpdateSimulationCase_updateSimulationCase_simulationCase;
}

export interface UpdateSimulationCase {
  updateSimulationCase: UpdateSimulationCase_updateSimulationCase | null;
}

export interface UpdateSimulationCaseVariables {
  input: UpdateSimulationCaseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSimulationCase
// ====================================================

export interface CreateSimulationCase_createSimulationCase_simulationCase_instantReferral {
  __typename: "Referral";
  referralValue: boolean | null;
  referralContent: string | null;
}

export interface CreateSimulationCase_createSimulationCase_simulationCase_diagnosis {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface CreateSimulationCase_createSimulationCase_simulationCase_treatment {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface CreateSimulationCase_createSimulationCase_simulationCase_referral {
  __typename: "ClinicalOutcome";
  possibleOutcome: string | null;
  isCorrectOutcome: boolean | null;
}

export interface CreateSimulationCase_createSimulationCase_simulationCase_patientInformation {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface CreateSimulationCase_createSimulationCase_simulationCase_assessments_testResult {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface CreateSimulationCase_createSimulationCase_simulationCase_assessments {
  __typename: "ClinicalTest";
  testName: string | null;
  testResult: CreateSimulationCase_createSimulationCase_simulationCase_assessments_testResult | null;
}

export interface CreateSimulationCase_createSimulationCase_simulationCase {
  __typename: "SimulationCase";
  title: string;
  instantReferral: CreateSimulationCase_createSimulationCase_simulationCase_instantReferral | null;
  diagnosis: (CreateSimulationCase_createSimulationCase_simulationCase_diagnosis | null)[] | null;
  treatment: (CreateSimulationCase_createSimulationCase_simulationCase_treatment | null)[] | null;
  referral: (CreateSimulationCase_createSimulationCase_simulationCase_referral | null)[] | null;
  patientInformation: CreateSimulationCase_createSimulationCase_simulationCase_patientInformation | null;
  assessments: (CreateSimulationCase_createSimulationCase_simulationCase_assessments | null)[] | null;
  status: ContentStatus | null;
  module: string | null;
  difficulty: string | null;
  clinicalCategory: string | null;
}

export interface CreateSimulationCase_createSimulationCase {
  __typename: "CreateSimulationCasePayLoad";
  simulationCase: CreateSimulationCase_createSimulationCase_simulationCase;
}

export interface CreateSimulationCase {
  createSimulationCase: CreateSimulationCase_createSimulationCase | null;
}

export interface CreateSimulationCaseVariables {
  input: CreateSimulationCaseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SimulationCaseList
// ====================================================

export interface SimulationCaseList_simulationCaseList_patientInformation {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SimulationCaseList_simulationCaseList {
  __typename: "SimulationCase";
  id: string;
  title: string;
  patientInformation: SimulationCaseList_simulationCaseList_patientInformation | null;
  status: ContentStatus | null;
  module: string | null;
  difficulty: string | null;
  clinicalCategory: string | null;
}

export interface SimulationCaseList {
  simulationCaseList: SimulationCaseList_simulationCaseList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendSimulationCaseCompletionMessage
// ====================================================

export interface SendSimulationCaseCompletionMessage {
  sendSimulationCaseCompletionMessage: boolean;
}

export interface SendSimulationCaseCompletionMessageVariables {
  input: SimulationCaseCompletionMessageInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStudyProgrammeExamSyllabi
// ====================================================

export interface GetStudyProgrammeExamSyllabi_studyProgrammeById_examSyllabusElements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
  status: ContentStatus;
}

export interface GetStudyProgrammeExamSyllabi_studyProgrammeById_examSyllabusElements {
  __typename: "StudyProgrammeElement";
  content: GetStudyProgrammeExamSyllabi_studyProgrammeById_examSyllabusElements_content;
}

export interface GetStudyProgrammeExamSyllabi_studyProgrammeById {
  __typename: "StudyProgramme";
  title: string;
  id: string;
  examSyllabusElements: GetStudyProgrammeExamSyllabi_studyProgrammeById_examSyllabusElements[];
  status: ContentStatus;
}

export interface GetStudyProgrammeExamSyllabi {
  /**
   * StudyProgramme
   */
  studyProgrammeById: GetStudyProgrammeExamSyllabi_studyProgrammeById;
}

export interface GetStudyProgrammeExamSyllabiVariables {
  studyProgrammeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateFeedbackResponse
// ====================================================

export interface CreateFeedbackResponse_createFeedbackResponse_feedback {
  __typename: "Feedback";
  id: string;
}

export interface CreateFeedbackResponse_createFeedbackResponse {
  __typename: "CreateFeedbackResponsePayload";
  feedback: CreateFeedbackResponse_createFeedbackResponse_feedback;
}

export interface CreateFeedbackResponse {
  createFeedbackResponse: CreateFeedbackResponse_createFeedbackResponse;
}

export interface CreateFeedbackResponseVariables {
  input: CreateFeedbackResponseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateStudentFeedback
// ====================================================

export interface CreateStudentFeedback_createStudentFeedback_feedback {
  __typename: "Feedback";
  id: string;
}

export interface CreateStudentFeedback_createStudentFeedback {
  __typename: "CreateStudentFeedbackPayload";
  feedback: CreateStudentFeedback_createStudentFeedback_feedback;
}

export interface CreateStudentFeedback {
  createStudentFeedback: CreateStudentFeedback_createStudentFeedback;
}

export interface CreateStudentFeedbackVariables {
  input: CreateStudentFeedbackInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFeedbackById
// ====================================================

export interface GetFeedbackById_feedbackById_messages_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetFeedbackById_feedbackById_messages_submittedBy {
  __typename: "User";
  id: string;
  fullName: string | null;
}

export interface GetFeedbackById_feedbackById_messages {
  __typename: "FeedbackMessage";
  id: string;
  removedAt: DateTime | null;
  body: GetFeedbackById_feedbackById_messages_body | null;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: GetFeedbackById_feedbackById_messages_submittedBy | null;
  submittedAt: DateTime;
}

export interface GetFeedbackById_feedbackById {
  __typename: "Feedback";
  id: string;
  messages: GetFeedbackById_feedbackById_messages[];
}

export interface GetFeedbackById {
  feedbackById: GetFeedbackById_feedbackById | null;
}

export interface GetFeedbackByIdVariables {
  feedbackId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveFeedbackMessage
// ====================================================

export interface RemoveFeedbackMessage_removeFeedbackMessage_feedback_messages_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface RemoveFeedbackMessage_removeFeedbackMessage_feedback_messages_submittedBy {
  __typename: "User";
  id: string;
  fullName: string | null;
}

export interface RemoveFeedbackMessage_removeFeedbackMessage_feedback_messages {
  __typename: "FeedbackMessage";
  id: string;
  removedAt: DateTime | null;
  body: RemoveFeedbackMessage_removeFeedbackMessage_feedback_messages_body | null;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: RemoveFeedbackMessage_removeFeedbackMessage_feedback_messages_submittedBy | null;
  submittedAt: DateTime;
}

export interface RemoveFeedbackMessage_removeFeedbackMessage_feedback {
  __typename: "Feedback";
  id: string;
  messages: RemoveFeedbackMessage_removeFeedbackMessage_feedback_messages[];
}

export interface RemoveFeedbackMessage_removeFeedbackMessage {
  __typename: "RemoveFeedbackMessagePayload";
  feedback: RemoveFeedbackMessage_removeFeedbackMessage_feedback;
}

export interface RemoveFeedbackMessage {
  removeFeedbackMessage: RemoveFeedbackMessage_removeFeedbackMessage;
}

export interface RemoveFeedbackMessageVariables {
  input: RemoveFeedbackMessageInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateGroupingQuestionAnswer
// ====================================================

export interface CreateGroupingQuestionAnswer_createMultipleChoiceAnswer_multipleChoiceAnswer {
  __typename: "MultipleChoiceAnswer";
  id: string;
  /**
   * From 0 to 1. 1 = 100%.
   */
  scoreInPercent: number | null;
}

export interface CreateGroupingQuestionAnswer_createMultipleChoiceAnswer {
  __typename: "CreateMultipleChoiceAnswerPayload";
  multipleChoiceAnswer: CreateGroupingQuestionAnswer_createMultipleChoiceAnswer_multipleChoiceAnswer;
}

export interface CreateGroupingQuestionAnswer {
  createMultipleChoiceAnswer: CreateGroupingQuestionAnswer_createMultipleChoiceAnswer;
}

export interface CreateGroupingQuestionAnswerVariables {
  multipleChoiceId: string;
  groupingCategoryAnswers: GroupingCategoryAnswer[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMultipleChoiceAnswer
// ====================================================

export interface CreateMultipleChoiceAnswer_createMultipleChoiceAnswer_multipleChoiceAnswer {
  __typename: "MultipleChoiceAnswer";
  id: string;
  /**
   * From 0 to 1. 1 = 100%.
   */
  scoreInPercent: number | null;
}

export interface CreateMultipleChoiceAnswer_createMultipleChoiceAnswer {
  __typename: "CreateMultipleChoiceAnswerPayload";
  multipleChoiceAnswer: CreateMultipleChoiceAnswer_createMultipleChoiceAnswer_multipleChoiceAnswer;
}

export interface CreateMultipleChoiceAnswer {
  createMultipleChoiceAnswer: CreateMultipleChoiceAnswer_createMultipleChoiceAnswer;
}

export interface CreateMultipleChoiceAnswerVariables {
  multiplechoiceId: string;
  selectedOptions: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetArticleData
// ====================================================

export interface GetArticleData_articleById_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetArticleData_articleById_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetArticleData_articleById_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetArticleData_articleById_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetArticleData_articleById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetArticleData_articleById {
  __typename: "Article";
  id: string;
  title: string;
  body: GetArticleData_articleById_body | null;
  relevantContent: GetArticleData_articleById_relevantContent | null;
  youtubeVideoId: string | null;
  canUpdateDetails: GetArticleData_articleById_canUpdateDetails;
  canCreateProgression: GetArticleData_articleById_canCreateProgression;
  context: GetArticleData_articleById_context[];
}

export interface GetArticleData {
  articleById: GetArticleData_articleById | null;
}

export interface GetArticleDataVariables {
  articleId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetArticleParentFolder
// ====================================================

export interface GetArticleParentFolder_folderById_elements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetArticleParentFolder_folderById_elements {
  __typename: "FolderElement";
  id: string;
  content: GetArticleParentFolder_folderById_elements_content;
}

export interface GetArticleParentFolder_folderById {
  __typename: "Folder";
  elements: GetArticleParentFolder_folderById_elements[];
}

export interface GetArticleParentFolder {
  folderById: GetArticleParentFolder_folderById | null;
}

export interface GetArticleParentFolderVariables {
  folderId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetKurssloeyfeParentFolder
// ====================================================

export interface GetKurssloeyfeParentFolder_folderById_elements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetKurssloeyfeParentFolder_folderById_elements {
  __typename: "FolderElement";
  id: string;
  content: GetKurssloeyfeParentFolder_folderById_elements_content;
}

export interface GetKurssloeyfeParentFolder_folderById {
  __typename: "Folder";
  elements: GetKurssloeyfeParentFolder_folderById_elements[];
}

export interface GetKurssloeyfeParentFolder {
  folderById: GetKurssloeyfeParentFolder_folderById | null;
}

export interface GetKurssloeyfeParentFolderVariables {
  folderId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetExamSyllabusPage
// ====================================================

export interface GetExamSyllabusPage_examSyllabusById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetExamSyllabusPage_examSyllabusById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetExamSyllabusPage_examSyllabusById_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_progression {
  __typename: "Progression";
  allContentIds: string[];
  finishedContentIds: string[];
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "MultipleChoice" | "StudyProgramme";
  context: GetExamSyllabusPage_examSyllabusById_elements_content_ExamSyllabus_context[];
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_Article_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_Article {
  __typename: "Article";
  context: GetExamSyllabusPage_examSyllabusById_elements_content_Article_context[];
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_Kurssloeyfe_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  context: GetExamSyllabusPage_examSyllabusById_elements_content_Kurssloeyfe_context[];
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_Folder_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetExamSyllabusPage_examSyllabusById_elements_content_Folder {
  __typename: "Folder";
  context: GetExamSyllabusPage_examSyllabusById_elements_content_Folder_context[];
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type GetExamSyllabusPage_examSyllabusById_elements_content = GetExamSyllabusPage_examSyllabusById_elements_content_ExamSyllabus | GetExamSyllabusPage_examSyllabusById_elements_content_Article | GetExamSyllabusPage_examSyllabusById_elements_content_Kurssloeyfe | GetExamSyllabusPage_examSyllabusById_elements_content_Folder;

export interface GetExamSyllabusPage_examSyllabusById_elements {
  __typename: "ExamSyllabusElement";
  id: string;
  progression: GetExamSyllabusPage_examSyllabusById_elements_progression | null;
  content: GetExamSyllabusPage_examSyllabusById_elements_content;
}

export interface GetExamSyllabusPage_examSyllabusById_progression {
  __typename: "Progression";
  allContentIds: string[];
  finishedContentIds: string[];
}

export interface GetExamSyllabusPage_examSyllabusById {
  __typename: "ExamSyllabus";
  id: string;
  title: string;
  status: ContentStatus;
  context: GetExamSyllabusPage_examSyllabusById_context[];
  description: GetExamSyllabusPage_examSyllabusById_description | null;
  canUpdateDetails: GetExamSyllabusPage_examSyllabusById_canUpdateDetails;
  elements: GetExamSyllabusPage_examSyllabusById_elements[];
  examDate: LocalDate | null;
  studyPoints: number;
  progression: GetExamSyllabusPage_examSyllabusById_progression;
}

export interface GetExamSyllabusPage {
  /**
   * ExamSyllabus
   */
  examSyllabusById: GetExamSyllabusPage_examSyllabusById | null;
}

export interface GetExamSyllabusPageVariables {
  examId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFeedbackPageData
// ====================================================

export interface GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder_folder {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder {
  __typename: "FeedbackGivenOnFolder";
  elementId: string;
  folder: GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder_folder;
}

export interface GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe {
  __typename: "FeedbackGivenOnKurssloeyfe";
  elementId: string;
  kurssloeyfe: GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe;
}

export interface GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase_simulationCase {
  __typename: "SimulationCase";
  id: string;
  title: string;
}

export interface GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase {
  __typename: "FeedbackGivenOnSimulationCase";
  elementId: string;
  simulationCase: GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase_simulationCase;
}

export type GetFeedbackPageData_feedbackList_givenOn = GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder | GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe | GetFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase;

export interface GetFeedbackPageData_feedbackList_messages_submittedBy {
  __typename: "User";
  id: string;
}

export interface GetFeedbackPageData_feedbackList_messages_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface GetFeedbackPageData_feedbackList_messages {
  __typename: "FeedbackMessage";
  submittedAt: DateTime;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: GetFeedbackPageData_feedbackList_messages_submittedBy | null;
  body: GetFeedbackPageData_feedbackList_messages_body | null;
}

export interface GetFeedbackPageData_feedbackList {
  __typename: "Feedback";
  id: string;
  givenOn: GetFeedbackPageData_feedbackList_givenOn | null;
  messages: GetFeedbackPageData_feedbackList_messages[];
}

export interface GetFeedbackPageData {
  feedbackList: GetFeedbackPageData_feedbackList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFolderPageData
// ====================================================

export interface GetFolderPageData_folderById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetFolderPageData_folderById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetFolderPageData_folderById_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetFolderPageData_folderById_elements_progression {
  __typename: "Progression";
  finishedContentIds: string[];
  allContentIds: string[];
}

export interface GetFolderPageData_folderById_elements_parent {
  __typename: "Folder";
  id: string;
}

export interface GetFolderPageData_folderById_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetFolderPageData_folderById_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export interface GetFolderPageData_folderById_elements_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetFolderPageData_folderById_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type GetFolderPageData_folderById_elements_content = GetFolderPageData_folderById_elements_content_ExamSyllabus | GetFolderPageData_folderById_elements_content_Article | GetFolderPageData_folderById_elements_content_Kurssloeyfe | GetFolderPageData_folderById_elements_content_Folder;

export interface GetFolderPageData_folderById_elements {
  __typename: "FolderElement";
  id: string;
  finished: boolean | null;
  progression: GetFolderPageData_folderById_elements_progression | null;
  parent: GetFolderPageData_folderById_elements_parent;
  content: GetFolderPageData_folderById_elements_content;
}

export interface GetFolderPageData_folderById {
  __typename: "Folder";
  id: string;
  title: string;
  status: ContentStatus;
  context: GetFolderPageData_folderById_context[];
  type: FolderType;
  description: GetFolderPageData_folderById_description | null;
  canUpdateDetails: GetFolderPageData_folderById_canUpdateDetails;
  elements: GetFolderPageData_folderById_elements[];
}

export interface GetFolderPageData {
  folderById: GetFolderPageData_folderById | null;
}

export interface GetFolderPageDataVariables {
  folderId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetKurssloeyfeData
// ====================================================

export interface GetKurssloeyfeData_kurssloeyfeById_progression {
  __typename: "Progression";
  finishedContentIds: string[];
  allContentIds: string[];
}

export interface GetKurssloeyfeData_kurssloeyfeById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
  context: GetKurssloeyfeData_kurssloeyfeById_elements_content_ExamSyllabus_context[];
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_relevantContent {
  __typename: "MultilineText";
  content: string;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  context: GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_context[];
  youtubeVideoId: string | null;
  relevantContent: GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_relevantContent | null;
  body: GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_body | null;
  canCreateProgression: GetKurssloeyfeData_kurssloeyfeById_elements_content_Article_canCreateProgression;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_latestSubmitted {
  __typename: "MultipleChoiceAnswer";
  /**
   * From 0 to 1. 1 = 100%.
   */
  scoreInPercent: number | null;
  submittedAt: DateTime;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_questions_options[] | null;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice {
  __typename: "MultipleChoice";
  id: string;
  status: ContentStatus;
  title: string;
  context: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_context[];
  type: MultipleChoiceType;
  ingress: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_ingress | null;
  relevantContent: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_relevantContent | null;
  latestSubmitted: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_latestSubmitted | null;
  /**
   * used if the exercise is a grouping exercise
   */
  options: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_options[];
  questions: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_questions[];
  canUpdateDetails: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_canUpdateDetails;
  canCreateProgression: GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice_canCreateProgression;
}

export type GetKurssloeyfeData_kurssloeyfeById_elements_content = GetKurssloeyfeData_kurssloeyfeById_elements_content_ExamSyllabus | GetKurssloeyfeData_kurssloeyfeById_elements_content_Article | GetKurssloeyfeData_kurssloeyfeById_elements_content_MultipleChoice;

export interface GetKurssloeyfeData_kurssloeyfeById_elements {
  __typename: "KurssloeyfeElement";
  finished: boolean;
  id: string;
  content: GetKurssloeyfeData_kurssloeyfeById_elements_content;
}

export interface GetKurssloeyfeData_kurssloeyfeById_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetKurssloeyfeData_kurssloeyfeById {
  __typename: "Kurssloeyfe";
  id: string;
  progression: GetKurssloeyfeData_kurssloeyfeById_progression;
  title: string;
  context: GetKurssloeyfeData_kurssloeyfeById_context[];
  elements: GetKurssloeyfeData_kurssloeyfeById_elements[];
  canUpdateDetails: GetKurssloeyfeData_kurssloeyfeById_canUpdateDetails;
}

export interface GetKurssloeyfeData {
  kurssloeyfeById: GetKurssloeyfeData_kurssloeyfeById | null;
}

export interface GetKurssloeyfeDataVariables {
  containerId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: KurssloeyfeData
// ====================================================

export interface KurssloeyfeData_kurssloeyfeById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface KurssloeyfeData_kurssloeyfeById_elements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
}

export interface KurssloeyfeData_kurssloeyfeById_elements {
  __typename: "KurssloeyfeElement";
  id: string;
  content: KurssloeyfeData_kurssloeyfeById_elements_content;
}

export interface KurssloeyfeData_kurssloeyfeById {
  __typename: "Kurssloeyfe";
  id: string;
  status: ContentStatus;
  title: string;
  context: KurssloeyfeData_kurssloeyfeById_context[];
  elements: KurssloeyfeData_kurssloeyfeById_elements[];
}

export interface KurssloeyfeData {
  kurssloeyfeById: KurssloeyfeData_kurssloeyfeById | null;
}

export interface KurssloeyfeDataVariables {
  kurssloeyfeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStudyProgrammesData
// ====================================================

export interface GetStudyProgrammesData_studyProgrammeList {
  __typename: "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetStudyProgrammesData {
  studyProgrammeList: GetStudyProgrammesData_studyProgrammeList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMultipleChoiceData
// ====================================================

export interface GetMultipleChoiceData_multipleChoiceById_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetMultipleChoiceData_multipleChoiceById_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetMultipleChoiceData_multipleChoiceById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetMultipleChoiceData_multipleChoiceById_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetMultipleChoiceData_multipleChoiceById_latestSubmitted {
  __typename: "MultipleChoiceAnswer";
  /**
   * From 0 to 1. 1 = 100%.
   */
  scoreInPercent: number | null;
  submittedAt: DateTime;
}

export interface GetMultipleChoiceData_multipleChoiceById_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface GetMultipleChoiceData_multipleChoiceById_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetMultipleChoiceData_multipleChoiceById_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface GetMultipleChoiceData_multipleChoiceById_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: GetMultipleChoiceData_multipleChoiceById_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: GetMultipleChoiceData_multipleChoiceById_questions_options[] | null;
}

export interface GetMultipleChoiceData_multipleChoiceById_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetMultipleChoiceData_multipleChoiceById {
  __typename: "MultipleChoice";
  id: string;
  title: string;
  relevantContent: GetMultipleChoiceData_multipleChoiceById_relevantContent | null;
  canUpdateDetails: GetMultipleChoiceData_multipleChoiceById_canUpdateDetails;
  context: GetMultipleChoiceData_multipleChoiceById_context[];
  type: MultipleChoiceType;
  ingress: GetMultipleChoiceData_multipleChoiceById_ingress | null;
  latestSubmitted: GetMultipleChoiceData_multipleChoiceById_latestSubmitted | null;
  /**
   * used if the exercise is a grouping exercise
   */
  options: GetMultipleChoiceData_multipleChoiceById_options[];
  questions: GetMultipleChoiceData_multipleChoiceById_questions[];
  canCreateProgression: GetMultipleChoiceData_multipleChoiceById_canCreateProgression;
}

export interface GetMultipleChoiceData {
  multipleChoiceById: GetMultipleChoiceData_multipleChoiceById | null;
}

export interface GetMultipleChoiceDataVariables {
  multipleChoiceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMCParentFolder
// ====================================================

export interface GetMCParentFolder_folderById_elements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetMCParentFolder_folderById_elements {
  __typename: "FolderElement";
  id: string;
  content: GetMCParentFolder_folderById_elements_content;
}

export interface GetMCParentFolder_folderById {
  __typename: "Folder";
  elements: GetMCParentFolder_folderById_elements[];
}

export interface GetMCParentFolder {
  folderById: GetMCParentFolder_folderById | null;
}

export interface GetMCParentFolderVariables {
  folderId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMyExamSyllabussData
// ====================================================

export interface GetMyExamSyllabussData_examSyllabusList {
  __typename: "ExamSyllabus";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetMyExamSyllabussData {
  examSyllabusList: GetMyExamSyllabussData_examSyllabusList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestPersonalInfo
// ====================================================

export interface RequestPersonalInfo_requestPersonalInfo_user {
  __typename: "User";
  id: string;
}

export interface RequestPersonalInfo_requestPersonalInfo {
  __typename: "RequestPersonalInfoPayload";
  user: RequestPersonalInfo_requestPersonalInfo_user;
}

export interface RequestPersonalInfo {
  requestPersonalInfo: RequestPersonalInfo_requestPersonalInfo;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAccount
// ====================================================

export interface DeleteAccount_requestDeleteUserAccount_user {
  __typename: "User";
  id: string;
}

export interface DeleteAccount_requestDeleteUserAccount {
  __typename: "RequestDeleteUserAccountPayload";
  user: DeleteAccount_requestDeleteUserAccount_user;
}

export interface DeleteAccount {
  requestDeleteUserAccount: DeleteAccount_requestDeleteUserAccount;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSelfAssessment
// ====================================================

export interface GetSelfAssessment_selfAssessmentById_articles_content_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetSelfAssessment_selfAssessmentById_articles_content_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetSelfAssessment_selfAssessmentById_articles_content_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetSelfAssessment_selfAssessmentById_articles_content_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetSelfAssessment_selfAssessmentById_articles_content {
  __typename: "Article";
  id: string;
  title: string;
  status: ContentStatus;
  context: GetSelfAssessment_selfAssessmentById_articles_content_context[];
  body: GetSelfAssessment_selfAssessmentById_articles_content_body | null;
  youtubeVideoId: string | null;
  canUpdateDetails: GetSelfAssessment_selfAssessmentById_articles_content_canUpdateDetails;
  canCreateProgression: GetSelfAssessment_selfAssessmentById_articles_content_canCreateProgression;
}

export interface GetSelfAssessment_selfAssessmentById_articles {
  __typename: "SelfAssessmentArticle";
  id: string;
  content: GetSelfAssessment_selfAssessmentById_articles_content;
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_questions_options[] | null;
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content {
  __typename: "MultipleChoice";
  type: MultipleChoiceType;
  id: string;
  title: string;
  status: ContentStatus;
  context: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_context[];
  canUpdateDetails: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_canUpdateDetails;
  canCreateProgression: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_canCreateProgression;
  questions: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content_questions[];
}

export interface GetSelfAssessment_selfAssessmentById_multipleChoiceExercises {
  __typename: "SelfAssessmentMultipleChoiceExercise";
  id: string;
  content: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises_content;
}

export interface GetSelfAssessment_selfAssessmentById_delivery_score {
  __typename: "Score";
  factorPercent: number;
}

export interface GetSelfAssessment_selfAssessmentById_delivery {
  __typename: "SelfAssessmentDelivery";
  deliveredAt: DateTime;
  score: GetSelfAssessment_selfAssessmentById_delivery_score;
}

export interface GetSelfAssessment_selfAssessmentById {
  __typename: "SelfAssessment";
  id: string;
  title: string;
  originFolderId: string;
  originFolderParentId: string;
  status: SelfAssessmentStatus;
  articles: GetSelfAssessment_selfAssessmentById_articles[];
  multipleChoiceExercises: GetSelfAssessment_selfAssessmentById_multipleChoiceExercises[];
  delivery: GetSelfAssessment_selfAssessmentById_delivery | null;
}

export interface GetSelfAssessment {
  selfAssessmentById: GetSelfAssessment_selfAssessmentById | null;
}

export interface GetSelfAssessmentVariables {
  containerId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSelfAssessmentById
// ====================================================

export interface GetSelfAssessmentById_selfAssessmentById_delivery_score {
  __typename: "Score";
  factorPercent: number;
}

export interface GetSelfAssessmentById_selfAssessmentById_delivery {
  __typename: "SelfAssessmentDelivery";
  deliveredAt: DateTime;
  score: GetSelfAssessmentById_selfAssessmentById_delivery_score;
}

export interface GetSelfAssessmentById_selfAssessmentById {
  __typename: "SelfAssessment";
  id: string;
  title: string;
  originFolderId: string;
  originFolderParentId: string;
  status: SelfAssessmentStatus;
  delivery: GetSelfAssessmentById_selfAssessmentById_delivery | null;
}

export interface GetSelfAssessmentById {
  selfAssessmentById: GetSelfAssessmentById_selfAssessmentById | null;
}

export interface GetSelfAssessmentByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStudyProgrammePageData
// ====================================================

export interface GetStudyProgrammePageData_studyProgrammeById_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetStudyProgrammePageData_studyProgrammeById_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface GetStudyProgrammePageData_studyProgrammeById_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface GetStudyProgrammePageData_studyProgrammeById_examSyllabusElements_parent {
  __typename: "StudyProgramme";
  id: string;
}

export interface GetStudyProgrammePageData_studyProgrammeById_examSyllabusElements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetStudyProgrammePageData_studyProgrammeById_examSyllabusElements {
  __typename: "StudyProgrammeElement";
  id: string;
  parent: GetStudyProgrammePageData_studyProgrammeById_examSyllabusElements_parent;
  content: GetStudyProgrammePageData_studyProgrammeById_examSyllabusElements_content;
}

export interface GetStudyProgrammePageData_studyProgrammeById_folderElements_parent {
  __typename: "StudyProgramme";
  id: string;
}

export interface GetStudyProgrammePageData_studyProgrammeById_folderElements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface GetStudyProgrammePageData_studyProgrammeById_folderElements {
  __typename: "StudyProgrammeElement";
  id: string;
  parent: GetStudyProgrammePageData_studyProgrammeById_folderElements_parent;
  content: GetStudyProgrammePageData_studyProgrammeById_folderElements_content;
}

export interface GetStudyProgrammePageData_studyProgrammeById {
  __typename: "StudyProgramme";
  id: string;
  title: string;
  status: ContentStatus;
  context: GetStudyProgrammePageData_studyProgrammeById_context[];
  description: GetStudyProgrammePageData_studyProgrammeById_description;
  canUpdateDetails: GetStudyProgrammePageData_studyProgrammeById_canUpdateDetails;
  examSyllabusElements: GetStudyProgrammePageData_studyProgrammeById_examSyllabusElements[];
  folderElements: GetStudyProgrammePageData_studyProgrammeById_folderElements[];
}

export interface GetStudyProgrammePageData {
  /**
   * StudyProgramme
   */
  studyProgrammeById: GetStudyProgrammePageData_studyProgrammeById;
}

export interface GetStudyProgrammePageDataVariables {
  studyProgrammeId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTeacherFeedbackPageData
// ====================================================

export interface GetTeacherFeedbackPageData_feedbackList_messages_submittedBy {
  __typename: "User";
  id: string;
}

export interface GetTeacherFeedbackPageData_feedbackList_messages_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface GetTeacherFeedbackPageData_feedbackList_messages {
  __typename: "FeedbackMessage";
  submittedAt: DateTime;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: GetTeacherFeedbackPageData_feedbackList_messages_submittedBy | null;
  body: GetTeacherFeedbackPageData_feedbackList_messages_body | null;
}

export interface GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase {
  __typename: "FeedbackGivenOnSimulationCase";
}

export interface GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder_folder {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder {
  __typename: "FeedbackGivenOnFolder";
  elementId: string;
  folder: GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder_folder;
}

export interface GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe {
  __typename: "FeedbackGivenOnKurssloeyfe";
  elementId: string;
  kurssloeyfe: GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe;
}

export type GetTeacherFeedbackPageData_feedbackList_givenOn = GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase | GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnFolder | GetTeacherFeedbackPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe;

export interface GetTeacherFeedbackPageData_feedbackList {
  __typename: "Feedback";
  id: string;
  messages: GetTeacherFeedbackPageData_feedbackList_messages[];
  givenOn: GetTeacherFeedbackPageData_feedbackList_givenOn | null;
}

export interface GetTeacherFeedbackPageData {
  feedbackList: GetTeacherFeedbackPageData_feedbackList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTeacherQuestionsPageData
// ====================================================

export interface GetTeacherQuestionsPageData_feedbackList_messages_submittedBy {
  __typename: "User";
  id: string;
}

export interface GetTeacherQuestionsPageData_feedbackList_messages_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface GetTeacherQuestionsPageData_feedbackList_messages {
  __typename: "FeedbackMessage";
  submittedAt: DateTime;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: GetTeacherQuestionsPageData_feedbackList_messages_submittedBy | null;
  body: GetTeacherQuestionsPageData_feedbackList_messages_body | null;
}

export interface GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase {
  __typename: "FeedbackGivenOnSimulationCase";
}

export interface GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnFolder_folder {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnFolder {
  __typename: "FeedbackGivenOnFolder";
  elementId: string;
  folder: GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnFolder_folder;
}

export interface GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe {
  __typename: "FeedbackGivenOnKurssloeyfe";
  elementId: string;
  kurssloeyfe: GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe;
}

export type GetTeacherQuestionsPageData_feedbackList_givenOn = GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnSimulationCase | GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnFolder | GetTeacherQuestionsPageData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe;

export interface GetTeacherQuestionsPageData_feedbackList {
  __typename: "Feedback";
  id: string;
  messages: GetTeacherQuestionsPageData_feedbackList_messages[];
  givenOn: GetTeacherQuestionsPageData_feedbackList_givenOn | null;
}

export interface GetTeacherQuestionsPageData {
  feedbackList: GetTeacherQuestionsPageData_feedbackList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateConsent
// ====================================================

export interface UpdateConsent_updateUserConsents_user {
  __typename: "User";
  id: string;
}

export interface UpdateConsent_updateUserConsents {
  __typename: "UpdateUserConsentPayload";
  user: UpdateConsent_updateUserConsents_user;
}

export interface UpdateConsent {
  updateUserConsents: UpdateConsent_updateUserConsents;
}

export interface UpdateConsentVariables {
  input: UpdateUserConsentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConsentStatus
// ====================================================

export interface GetConsentStatus_consentStatusList_basis {
  __typename: "ConsentBasis";
  id: string;
  title: string;
  type: ConsentType;
  purpose: string;
  validFrom: DateTime;
}

export interface GetConsentStatus_consentStatusList {
  __typename: "UserConsent";
  isGiven: boolean;
  completed: boolean;
  basis: GetConsentStatus_consentStatusList_basis;
}

export interface GetConsentStatus {
  consentStatusList: GetConsentStatus_consentStatusList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAnsweredQuestionsData
// ====================================================

export interface GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnSimulationCase {
  __typename: "FeedbackGivenOnSimulationCase";
}

export interface GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder_folder {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder {
  __typename: "FeedbackGivenOnFolder";
  elementId: string;
  folder: GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder_folder;
}

export interface GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe {
  __typename: "FeedbackGivenOnKurssloeyfe";
  elementId: string;
  kurssloeyfe: GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe;
}

export type GetAnsweredQuestionsData_feedbackList_givenOn = GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnSimulationCase | GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder | GetAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe;

export interface GetAnsweredQuestionsData_feedbackList_messages_submittedBy {
  __typename: "User";
  id: string;
}

export interface GetAnsweredQuestionsData_feedbackList_messages_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface GetAnsweredQuestionsData_feedbackList_messages {
  __typename: "FeedbackMessage";
  submittedAt: DateTime;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: GetAnsweredQuestionsData_feedbackList_messages_submittedBy | null;
  body: GetAnsweredQuestionsData_feedbackList_messages_body | null;
}

export interface GetAnsweredQuestionsData_feedbackList {
  __typename: "Feedback";
  id: string;
  givenOn: GetAnsweredQuestionsData_feedbackList_givenOn | null;
  messages: GetAnsweredQuestionsData_feedbackList_messages[];
}

export interface GetAnsweredQuestionsData {
  feedbackList: GetAnsweredQuestionsData_feedbackList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AskQuestion
// ====================================================

export interface AskQuestion_createStudentFeedback_feedback {
  __typename: "Feedback";
  id: string;
}

export interface AskQuestion_createStudentFeedback {
  __typename: "CreateStudentFeedbackPayload";
  feedback: AskQuestion_createStudentFeedback_feedback;
}

export interface AskQuestion {
  createStudentFeedback: AskQuestion_createStudentFeedback;
}

export interface AskQuestionVariables {
  input: CreateStudentFeedbackInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUnAnsweredQuestionsData
// ====================================================

export interface GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnSimulationCase {
  __typename: "FeedbackGivenOnSimulationCase";
}

export interface GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder_folder {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder {
  __typename: "FeedbackGivenOnFolder";
  elementId: string;
  folder: GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder_folder;
}

export interface GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe {
  __typename: "FeedbackGivenOnKurssloeyfe";
  elementId: string;
  kurssloeyfe: GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe;
}

export type GetUnAnsweredQuestionsData_feedbackList_givenOn = GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnSimulationCase | GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnFolder | GetUnAnsweredQuestionsData_feedbackList_givenOn_FeedbackGivenOnKurssloeyfe;

export interface GetUnAnsweredQuestionsData_feedbackList_messages_submittedBy {
  __typename: "User";
  id: string;
}

export interface GetUnAnsweredQuestionsData_feedbackList_messages_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface GetUnAnsweredQuestionsData_feedbackList_messages {
  __typename: "FeedbackMessage";
  submittedAt: DateTime;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: GetUnAnsweredQuestionsData_feedbackList_messages_submittedBy | null;
  body: GetUnAnsweredQuestionsData_feedbackList_messages_body | null;
}

export interface GetUnAnsweredQuestionsData_feedbackList {
  __typename: "Feedback";
  id: string;
  givenOn: GetUnAnsweredQuestionsData_feedbackList_givenOn | null;
  messages: GetUnAnsweredQuestionsData_feedbackList_messages[];
}

export interface GetUnAnsweredQuestionsData {
  feedbackList: GetUnAnsweredQuestionsData_feedbackList[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeliverSelfAssessment
// ====================================================

export interface DeliverSelfAssessment_deliverSelfAssessment_selfAssessment_delivery_score {
  __typename: "Score";
  factorPercent: number;
}

export interface DeliverSelfAssessment_deliverSelfAssessment_selfAssessment_delivery {
  __typename: "SelfAssessmentDelivery";
  score: DeliverSelfAssessment_deliverSelfAssessment_selfAssessment_delivery_score;
  deliveredAt: DateTime;
}

export interface DeliverSelfAssessment_deliverSelfAssessment_selfAssessment {
  __typename: "SelfAssessment";
  id: string;
  delivery: DeliverSelfAssessment_deliverSelfAssessment_selfAssessment_delivery | null;
}

export interface DeliverSelfAssessment_deliverSelfAssessment {
  __typename: "DeliverSelfAssessmentPayload";
  selfAssessment: DeliverSelfAssessment_deliverSelfAssessment_selfAssessment;
}

export interface DeliverSelfAssessment {
  deliverSelfAssessment: DeliverSelfAssessment_deliverSelfAssessment;
}

export interface DeliverSelfAssessmentVariables {
  input: DeliverSelfAssessmentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelfAssessmentStarterMutation
// ====================================================

export interface SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles_content_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles_content_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles_content {
  __typename: "Article";
  id: string;
  title: string;
  youtubeVideoId: string | null;
  body: SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles_content_body | null;
  relevantContent: SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles_content_relevantContent | null;
}

export interface SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles {
  __typename: "SelfAssessmentArticle";
  id: string;
  content: SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles_content;
}

export interface SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_multipleChoiceExercises_content {
  __typename: "MultipleChoice";
  title: string;
  id: string;
}

export interface SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_multipleChoiceExercises {
  __typename: "SelfAssessmentMultipleChoiceExercise";
  id: string;
  content: SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_multipleChoiceExercises_content;
}

export interface SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment {
  __typename: "SelfAssessment";
  id: string;
  articles: SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_articles[];
  multipleChoiceExercises: SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment_multipleChoiceExercises[];
}

export interface SelfAssessmentStarterMutation_startSelfAssessment {
  __typename: "StartSelfAssessmentPayload";
  selfAssessment: SelfAssessmentStarterMutation_startSelfAssessment_selfAssessment;
}

export interface SelfAssessmentStarterMutation {
  startSelfAssessment: SelfAssessmentStarterMutation_startSelfAssessment;
}

export interface SelfAssessmentStarterMutationVariables {
  input: StartSelfAssessmentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelfAssessmentCancelMutation
// ====================================================

export interface SelfAssessmentCancelMutation_cancelSelfAssessment_selfAssessment {
  __typename: "SelfAssessment";
  id: string;
  originFolderId: string;
}

export interface SelfAssessmentCancelMutation_cancelSelfAssessment {
  __typename: "CancelSelfAssessmentPayload";
  selfAssessment: SelfAssessmentCancelMutation_cancelSelfAssessment_selfAssessment;
}

export interface SelfAssessmentCancelMutation {
  cancelSelfAssessment: SelfAssessmentCancelMutation_cancelSelfAssessment;
}

export interface SelfAssessmentCancelMutationVariables {
  input: CancelSelfAssessmentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SelfAssessmentStarterForFolder
// ====================================================

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_delivery_score {
  __typename: "Score";
  factorPercent: number;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_delivery {
  __typename: "SelfAssessmentDelivery";
  deliveredAt: DateTime;
  score: SelfAssessmentStarterForFolder_selfAssessmentForFolder_delivery_score;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles_content_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles_content_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles_content {
  __typename: "Article";
  id: string;
  title: string;
  youtubeVideoId: string | null;
  body: SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles_content_body | null;
  relevantContent: SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles_content_relevantContent | null;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles {
  __typename: "SelfAssessmentArticle";
  id: string;
  content: SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles_content;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_multipleChoiceExercises_content {
  __typename: "MultipleChoice";
  title: string;
  id: string;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder_multipleChoiceExercises {
  __typename: "SelfAssessmentMultipleChoiceExercise";
  id: string;
  content: SelfAssessmentStarterForFolder_selfAssessmentForFolder_multipleChoiceExercises_content;
}

export interface SelfAssessmentStarterForFolder_selfAssessmentForFolder {
  __typename: "SelfAssessment";
  id: string;
  originFolderId: string;
  status: SelfAssessmentStatus;
  delivery: SelfAssessmentStarterForFolder_selfAssessmentForFolder_delivery | null;
  articles: SelfAssessmentStarterForFolder_selfAssessmentForFolder_articles[];
  multipleChoiceExercises: SelfAssessmentStarterForFolder_selfAssessmentForFolder_multipleChoiceExercises[];
}

export interface SelfAssessmentStarterForFolder {
  selfAssessmentForFolder: SelfAssessmentStarterForFolder_selfAssessmentForFolder | null;
}

export interface SelfAssessmentStarterForFolderVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveStudyProgrammesForUser
// ====================================================

export interface SaveStudyProgrammesForUser_saveStudyProgrammesForUser_studyProgrammes {
  __typename: "StudyProgramme";
  title: string;
  id: string;
}

export interface SaveStudyProgrammesForUser_saveStudyProgrammesForUser {
  __typename: "SaveStudyProgrammesForUserPayload";
  studyProgrammes: SaveStudyProgrammesForUser_saveStudyProgrammesForUser_studyProgrammes[];
}

export interface SaveStudyProgrammesForUser {
  saveStudyProgrammesForUser: SaveStudyProgrammesForUser_saveStudyProgrammesForUser;
}

export interface SaveStudyProgrammesForUserVariables {
  input: SaveStudyProgrammesForUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StudyProgrammeElementFragment
// ====================================================

export interface StudyProgrammeElementFragment_parent {
  __typename: "StudyProgramme";
  id: string;
}

export interface StudyProgrammeElementFragment_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface StudyProgrammeElementFragment {
  __typename: "StudyProgrammeElement";
  id: string;
  parent: StudyProgrammeElementFragment_parent;
  content: StudyProgrammeElementFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ExamElementFragment
// ====================================================

export interface ExamElementFragment_progression {
  __typename: "Progression";
  allContentIds: string[];
  finishedContentIds: string[];
}

export interface ExamElementFragment_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementFragment_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "MultipleChoice" | "StudyProgramme";
  context: ExamElementFragment_content_ExamSyllabus_context[];
  id: string;
  status: ContentStatus;
  title: string;
}

export interface ExamElementFragment_content_Article_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementFragment_content_Article {
  __typename: "Article";
  context: ExamElementFragment_content_Article_context[];
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export interface ExamElementFragment_content_Kurssloeyfe_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementFragment_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  context: ExamElementFragment_content_Kurssloeyfe_context[];
  id: string;
  status: ContentStatus;
  title: string;
}

export interface ExamElementFragment_content_Folder_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementFragment_content_Folder {
  __typename: "Folder";
  context: ExamElementFragment_content_Folder_context[];
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type ExamElementFragment_content = ExamElementFragment_content_ExamSyllabus | ExamElementFragment_content_Article | ExamElementFragment_content_Kurssloeyfe | ExamElementFragment_content_Folder;

export interface ExamElementFragment {
  __typename: "ExamSyllabusElement";
  id: string;
  progression: ExamElementFragment_progression | null;
  content: ExamElementFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ExamElementListFragment
// ====================================================

export interface ExamElementListFragment_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface ExamElementListFragment_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface ExamElementListFragment_elements_progression {
  __typename: "Progression";
  allContentIds: string[];
  finishedContentIds: string[];
}

export interface ExamElementListFragment_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementListFragment_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "MultipleChoice" | "StudyProgramme";
  context: ExamElementListFragment_elements_content_ExamSyllabus_context[];
  id: string;
  status: ContentStatus;
  title: string;
}

export interface ExamElementListFragment_elements_content_Article_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementListFragment_elements_content_Article {
  __typename: "Article";
  context: ExamElementListFragment_elements_content_Article_context[];
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export interface ExamElementListFragment_elements_content_Kurssloeyfe_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementListFragment_elements_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  context: ExamElementListFragment_elements_content_Kurssloeyfe_context[];
  id: string;
  status: ContentStatus;
  title: string;
}

export interface ExamElementListFragment_elements_content_Folder_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ExamElementListFragment_elements_content_Folder {
  __typename: "Folder";
  context: ExamElementListFragment_elements_content_Folder_context[];
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type ExamElementListFragment_elements_content = ExamElementListFragment_elements_content_ExamSyllabus | ExamElementListFragment_elements_content_Article | ExamElementListFragment_elements_content_Kurssloeyfe | ExamElementListFragment_elements_content_Folder;

export interface ExamElementListFragment_elements {
  __typename: "ExamSyllabusElement";
  id: string;
  progression: ExamElementListFragment_elements_progression | null;
  content: ExamElementListFragment_elements_content;
}

export interface ExamElementListFragment {
  __typename: "ExamSyllabus";
  id: string;
  status: ContentStatus;
  description: ExamElementListFragment_description | null;
  canUpdateDetails: ExamElementListFragment_canUpdateDetails;
  elements: ExamElementListFragment_elements[];
  examDate: LocalDate | null;
  studyPoints: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StudyProgrammeElementListFragment
// ====================================================

export interface StudyProgrammeElementListFragment_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface StudyProgrammeElementListFragment_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface StudyProgrammeElementListFragment_examSyllabusElements_parent {
  __typename: "StudyProgramme";
  id: string;
}

export interface StudyProgrammeElementListFragment_examSyllabusElements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface StudyProgrammeElementListFragment_examSyllabusElements {
  __typename: "StudyProgrammeElement";
  id: string;
  parent: StudyProgrammeElementListFragment_examSyllabusElements_parent;
  content: StudyProgrammeElementListFragment_examSyllabusElements_content;
}

export interface StudyProgrammeElementListFragment_folderElements_parent {
  __typename: "StudyProgramme";
  id: string;
}

export interface StudyProgrammeElementListFragment_folderElements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface StudyProgrammeElementListFragment_folderElements {
  __typename: "StudyProgrammeElement";
  id: string;
  parent: StudyProgrammeElementListFragment_folderElements_parent;
  content: StudyProgrammeElementListFragment_folderElements_content;
}

export interface StudyProgrammeElementListFragment {
  __typename: "StudyProgramme";
  id: string;
  status: ContentStatus;
  description: StudyProgrammeElementListFragment_description;
  canUpdateDetails: StudyProgrammeElementListFragment_canUpdateDetails;
  examSyllabusElements: StudyProgrammeElementListFragment_examSyllabusElements[];
  folderElements: StudyProgrammeElementListFragment_folderElements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FolderElementFragment
// ====================================================

export interface FolderElementFragment_progression {
  __typename: "Progression";
  finishedContentIds: string[];
  allContentIds: string[];
}

export interface FolderElementFragment_parent {
  __typename: "Folder";
  id: string;
}

export interface FolderElementFragment_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface FolderElementFragment_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export interface FolderElementFragment_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface FolderElementFragment_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type FolderElementFragment_content = FolderElementFragment_content_ExamSyllabus | FolderElementFragment_content_Article | FolderElementFragment_content_Kurssloeyfe | FolderElementFragment_content_Folder;

export interface FolderElementFragment {
  __typename: "FolderElement";
  id: string;
  finished: boolean | null;
  progression: FolderElementFragment_progression | null;
  parent: FolderElementFragment_parent;
  content: FolderElementFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FolderElementListFragment
// ====================================================

export interface FolderElementListFragment_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  title: string;
  id: string;
}

export interface FolderElementListFragment_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface FolderElementListFragment_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface FolderElementListFragment_elements_progression {
  __typename: "Progression";
  finishedContentIds: string[];
  allContentIds: string[];
}

export interface FolderElementListFragment_elements_parent {
  __typename: "Folder";
  id: string;
}

export interface FolderElementListFragment_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface FolderElementListFragment_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export interface FolderElementListFragment_elements_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface FolderElementListFragment_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type FolderElementListFragment_elements_content = FolderElementListFragment_elements_content_ExamSyllabus | FolderElementListFragment_elements_content_Article | FolderElementListFragment_elements_content_Kurssloeyfe | FolderElementListFragment_elements_content_Folder;

export interface FolderElementListFragment_elements {
  __typename: "FolderElement";
  id: string;
  finished: boolean | null;
  progression: FolderElementListFragment_elements_progression | null;
  parent: FolderElementListFragment_elements_parent;
  content: FolderElementListFragment_elements_content;
}

export interface FolderElementListFragment {
  __typename: "Folder";
  id: string;
  title: string;
  type: FolderType;
  context: FolderElementListFragment_context[];
  description: FolderElementListFragment_description | null;
  canUpdateDetails: FolderElementListFragment_canUpdateDetails;
  elements: FolderElementListFragment_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminArticleFragment
// ====================================================

export interface AdminArticleFragment_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminArticleFragment_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminArticleFragment_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminArticleFragment {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
  context: AdminArticleFragment_context[];
  body: AdminArticleFragment_body | null;
  relevantContent: AdminArticleFragment_relevantContent | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminFolderFragment
// ====================================================

export interface AdminFolderFragment_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderFragment {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  description: AdminFolderFragment_description | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminMultipleChoiceFragment
// ====================================================

export interface AdminMultipleChoiceFragment_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminMultipleChoiceFragment_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminMultipleChoiceFragment_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminMultipleChoiceFragment_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminMultipleChoiceFragment_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface AdminMultipleChoiceFragment_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: AdminMultipleChoiceFragment_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: AdminMultipleChoiceFragment_questions_options[] | null;
}

export interface AdminMultipleChoiceFragment {
  __typename: "MultipleChoice";
  id: string;
  type: MultipleChoiceType;
  status: ContentStatus;
  title: string;
  context: AdminMultipleChoiceFragment_context[];
  ingress: AdminMultipleChoiceFragment_ingress | null;
  relevantContent: AdminMultipleChoiceFragment_relevantContent | null;
  questions: AdminMultipleChoiceFragment_questions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminMultipleChoiceQuestionOptionFragment
// ====================================================

export interface AdminMultipleChoiceQuestionOptionFragment {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminKurssloeyfeFragment
// ====================================================

export interface AdminKurssloeyfeFragment_elements_parent {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface AdminKurssloeyfeFragment_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface AdminKurssloeyfeFragment_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export type AdminKurssloeyfeFragment_elements_content = AdminKurssloeyfeFragment_elements_content_ExamSyllabus | AdminKurssloeyfeFragment_elements_content_Article;

export interface AdminKurssloeyfeFragment_elements {
  __typename: "KurssloeyfeElement";
  parent: AdminKurssloeyfeFragment_elements_parent;
  id: string;
  content: AdminKurssloeyfeFragment_elements_content;
}

export interface AdminKurssloeyfeFragment {
  __typename: "Kurssloeyfe";
  id: string;
  status: ContentStatus;
  title: string;
  elements: AdminKurssloeyfeFragment_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminFolderElementParentFragment
// ====================================================

export interface AdminFolderElementParentFragment_parent {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface AdminFolderElementParentFragment {
  __typename: "FolderElement";
  id: string;
  parent: AdminFolderElementParentFragment_parent;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentFragment
// ====================================================

export interface ContentFragment {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentFolderFragment
// ====================================================

export interface ContentFolderFragment_parent {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface ContentFolderFragment_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ContentFolderFragment {
  __typename: "FolderElement";
  id: string;
  parent: ContentFolderFragment_parent;
  content: ContentFolderFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminFolderKurssloeyfeFragment
// ====================================================

export interface AdminFolderKurssloeyfeFragment_content_Article {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_parent {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export type AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_content = AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_content_ExamSyllabus | AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_content_Article;

export interface AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements {
  __typename: "KurssloeyfeElement";
  parent: AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_parent;
  id: string;
  content: AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements_content;
}

export interface AdminFolderKurssloeyfeFragment_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
  status: ContentStatus;
  elements: AdminFolderKurssloeyfeFragment_content_Kurssloeyfe_elements[];
}

export type AdminFolderKurssloeyfeFragment_content = AdminFolderKurssloeyfeFragment_content_Article | AdminFolderKurssloeyfeFragment_content_Kurssloeyfe;

export interface AdminFolderKurssloeyfeFragment {
  __typename: "FolderElement";
  id: string;
  content: AdminFolderKurssloeyfeFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminKurssloeyfeElementParentFragment
// ====================================================

export interface AdminKurssloeyfeElementParentFragment_parent_folder {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface AdminKurssloeyfeElementParentFragment_parent {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
  folder: AdminKurssloeyfeElementParentFragment_parent_folder | null;
}

export interface AdminKurssloeyfeElementParentFragment {
  __typename: "KurssloeyfeElement";
  id: string;
  parent: AdminKurssloeyfeElementParentFragment_parent;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminKurssloeyfeArticleFragment
// ====================================================

export interface AdminKurssloeyfeArticleFragment_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminKurssloeyfeArticleFragment_content_Article_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminKurssloeyfeArticleFragment_content_Article_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminKurssloeyfeArticleFragment_content_Article_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminKurssloeyfeArticleFragment_content_Article {
  __typename: "Article";
  id: string;
  title: string;
  status: ContentStatus;
  youtubeVideoId: string | null;
  context: AdminKurssloeyfeArticleFragment_content_Article_context[];
  body: AdminKurssloeyfeArticleFragment_content_Article_body | null;
  relevantContent: AdminKurssloeyfeArticleFragment_content_Article_relevantContent | null;
}

export type AdminKurssloeyfeArticleFragment_content = AdminKurssloeyfeArticleFragment_content_ExamSyllabus | AdminKurssloeyfeArticleFragment_content_Article;

export interface AdminKurssloeyfeArticleFragment {
  __typename: "KurssloeyfeElement";
  id: string;
  content: AdminKurssloeyfeArticleFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminKurssloeyfeMultipleChoiceFragment
// ====================================================

export interface AdminKurssloeyfeMultipleChoiceFragment_content_Article {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_questions_options[] | null;
}

export interface AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice {
  __typename: "MultipleChoice";
  id: string;
  title: string;
  type: MultipleChoiceType;
  status: ContentStatus;
  context: AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_context[];
  ingress: AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_ingress | null;
  relevantContent: AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_relevantContent | null;
  questions: AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice_questions[];
}

export type AdminKurssloeyfeMultipleChoiceFragment_content = AdminKurssloeyfeMultipleChoiceFragment_content_Article | AdminKurssloeyfeMultipleChoiceFragment_content_MultipleChoice;

export interface AdminKurssloeyfeMultipleChoiceFragment {
  __typename: "KurssloeyfeElement";
  id: string;
  content: AdminKurssloeyfeMultipleChoiceFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminFolderRootFragment
// ====================================================

export interface AdminFolderRootFragment_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderRootFragment_elements_content_Article {
  __typename: "Article" | "ExamSyllabus" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface AdminFolderRootFragment_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
}

export type AdminFolderRootFragment_elements_content = AdminFolderRootFragment_elements_content_Article | AdminFolderRootFragment_elements_content_Folder;

export interface AdminFolderRootFragment_elements {
  __typename: "FolderElement";
  id: string;
  content: AdminFolderRootFragment_elements_content;
}

export interface AdminFolderRootFragment {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  description: AdminFolderRootFragment_description | null;
  elements: AdminFolderRootFragment_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminFolderElementRootFragment
// ====================================================

export interface AdminFolderElementRootFragment_parent_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderElementRootFragment_parent {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  description: AdminFolderElementRootFragment_parent_description | null;
}

export interface AdminFolderElementRootFragment_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminFolderElementRootFragment_content_Kurssloeyfe_elements_parent {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface AdminFolderElementRootFragment_content_Kurssloeyfe_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface AdminFolderElementRootFragment_content_Kurssloeyfe_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  youtubeVideoId: string | null;
}

export type AdminFolderElementRootFragment_content_Kurssloeyfe_elements_content = AdminFolderElementRootFragment_content_Kurssloeyfe_elements_content_ExamSyllabus | AdminFolderElementRootFragment_content_Kurssloeyfe_elements_content_Article;

export interface AdminFolderElementRootFragment_content_Kurssloeyfe_elements {
  __typename: "KurssloeyfeElement";
  parent: AdminFolderElementRootFragment_content_Kurssloeyfe_elements_parent;
  id: string;
  content: AdminFolderElementRootFragment_content_Kurssloeyfe_elements_content;
}

export interface AdminFolderElementRootFragment_content_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
  status: ContentStatus;
  elements: AdminFolderElementRootFragment_content_Kurssloeyfe_elements[];
}

export interface AdminFolderElementRootFragment_content_MultipleChoice_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminFolderElementRootFragment_content_MultipleChoice_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderElementRootFragment_content_MultipleChoice_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderElementRootFragment_content_MultipleChoice_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderElementRootFragment_content_MultipleChoice_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface AdminFolderElementRootFragment_content_MultipleChoice_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: AdminFolderElementRootFragment_content_MultipleChoice_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: AdminFolderElementRootFragment_content_MultipleChoice_questions_options[] | null;
}

export interface AdminFolderElementRootFragment_content_MultipleChoice {
  __typename: "MultipleChoice";
  id: string;
  title: string;
  type: MultipleChoiceType;
  status: ContentStatus;
  context: AdminFolderElementRootFragment_content_MultipleChoice_context[];
  ingress: AdminFolderElementRootFragment_content_MultipleChoice_ingress | null;
  relevantContent: AdminFolderElementRootFragment_content_MultipleChoice_relevantContent | null;
  questions: AdminFolderElementRootFragment_content_MultipleChoice_questions[];
}

export interface AdminFolderElementRootFragment_content_Article_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminFolderElementRootFragment_content_Article_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderElementRootFragment_content_Article_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminFolderElementRootFragment_content_Article {
  __typename: "Article";
  id: string;
  title: string;
  status: ContentStatus;
  youtubeVideoId: string | null;
  context: AdminFolderElementRootFragment_content_Article_context[];
  body: AdminFolderElementRootFragment_content_Article_body | null;
  relevantContent: AdminFolderElementRootFragment_content_Article_relevantContent | null;
}

export type AdminFolderElementRootFragment_content = AdminFolderElementRootFragment_content_ExamSyllabus | AdminFolderElementRootFragment_content_Kurssloeyfe | AdminFolderElementRootFragment_content_MultipleChoice | AdminFolderElementRootFragment_content_Article;

export interface AdminFolderElementRootFragment {
  __typename: "FolderElement";
  id: string;
  parent: AdminFolderElementRootFragment_parent;
  content: AdminFolderElementRootFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FeedbackListFragment
// ====================================================

export interface FeedbackListFragment_messages_submittedBy {
  __typename: "User";
  id: string;
}

export interface FeedbackListFragment_messages_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface FeedbackListFragment_messages {
  __typename: "FeedbackMessage";
  submittedAt: DateTime;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: FeedbackListFragment_messages_submittedBy | null;
  body: FeedbackListFragment_messages_body | null;
}

export interface FeedbackListFragment_givenOn_FeedbackGivenOnFolder_folder {
  __typename: "Folder";
  id: string;
  title: string;
}

export interface FeedbackListFragment_givenOn_FeedbackGivenOnFolder {
  __typename: "FeedbackGivenOnFolder";
  elementId: string;
  folder: FeedbackListFragment_givenOn_FeedbackGivenOnFolder_folder;
}

export interface FeedbackListFragment_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  title: string;
}

export interface FeedbackListFragment_givenOn_FeedbackGivenOnKurssloeyfe {
  __typename: "FeedbackGivenOnKurssloeyfe";
  elementId: string;
  kurssloeyfe: FeedbackListFragment_givenOn_FeedbackGivenOnKurssloeyfe_kurssloeyfe;
}

export interface FeedbackListFragment_givenOn_FeedbackGivenOnSimulationCase_simulationCase {
  __typename: "SimulationCase";
  id: string;
  title: string;
}

export interface FeedbackListFragment_givenOn_FeedbackGivenOnSimulationCase {
  __typename: "FeedbackGivenOnSimulationCase";
  elementId: string;
  simulationCase: FeedbackListFragment_givenOn_FeedbackGivenOnSimulationCase_simulationCase;
}

export type FeedbackListFragment_givenOn = FeedbackListFragment_givenOn_FeedbackGivenOnFolder | FeedbackListFragment_givenOn_FeedbackGivenOnKurssloeyfe | FeedbackListFragment_givenOn_FeedbackGivenOnSimulationCase;

export interface FeedbackListFragment {
  __typename: "Feedback";
  id: string;
  messages: FeedbackListFragment_messages[];
  givenOn: FeedbackListFragment_givenOn | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MultipleChoiceQuestionFragment
// ====================================================

export interface MultipleChoiceQuestionFragment_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface MultipleChoiceQuestionFragment_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface MultipleChoiceQuestionFragment {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: MultipleChoiceQuestionFragment_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: MultipleChoiceQuestionFragment_options[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AdminStudyProgrammeFragment
// ====================================================

export interface AdminStudyProgrammeFragment_description {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface AdminStudyProgrammeFragment_elements_content_Article {
  __typename: "Article" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
}

export interface AdminStudyProgrammeFragment_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminStudyProgrammeFragment_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus";
  id: string;
  status: ContentStatus;
  title: string;
  context: AdminStudyProgrammeFragment_elements_content_ExamSyllabus_context[];
}

export interface AdminStudyProgrammeFragment_elements_content_Folder_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface AdminStudyProgrammeFragment_elements_content_Folder {
  __typename: "Folder";
  id: string;
  status: ContentStatus;
  title: string;
  type: FolderType;
  context: AdminStudyProgrammeFragment_elements_content_Folder_context[];
}

export type AdminStudyProgrammeFragment_elements_content = AdminStudyProgrammeFragment_elements_content_Article | AdminStudyProgrammeFragment_elements_content_ExamSyllabus | AdminStudyProgrammeFragment_elements_content_Folder;

export interface AdminStudyProgrammeFragment_elements {
  __typename: "StudyProgrammeElement";
  id: string;
  content: AdminStudyProgrammeFragment_elements_content;
}

export interface AdminStudyProgrammeFragment {
  __typename: "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
  description: AdminStudyProgrammeFragment_description;
  elements: AdminStudyProgrammeFragment_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentProgressionFragment
// ====================================================

export interface ContentProgressionFragment_Article {
  __typename: "Article" | "MultipleChoice" | "StudyProgramme";
  id: string;
}

export interface ContentProgressionFragment_Folder_folderProgression {
  __typename: "Progression";
  allContentIds: string[];
  finishedContentIds: string[];
}

export interface ContentProgressionFragment_Folder {
  __typename: "Folder";
  id: string;
  folderProgression: ContentProgressionFragment_Folder_folderProgression | null;
}

export interface ContentProgressionFragment_Kurssloeyfe_progression {
  __typename: "Progression";
  allContentIds: string[];
  finishedContentIds: string[];
}

export interface ContentProgressionFragment_Kurssloeyfe {
  __typename: "Kurssloeyfe";
  id: string;
  progression: ContentProgressionFragment_Kurssloeyfe_progression;
}

export interface ContentProgressionFragment_ExamSyllabus_progression {
  __typename: "Progression";
  allContentIds: string[];
  finishedContentIds: string[];
}

export interface ContentProgressionFragment_ExamSyllabus {
  __typename: "ExamSyllabus";
  id: string;
  progression: ContentProgressionFragment_ExamSyllabus_progression;
}

export type ContentProgressionFragment = ContentProgressionFragment_Article | ContentProgressionFragment_Folder | ContentProgressionFragment_Kurssloeyfe | ContentProgressionFragment_ExamSyllabus;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GetFolderElementsFragment
// ====================================================

export interface GetFolderElementsFragment_elements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetFolderElementsFragment_elements {
  __typename: "FolderElement";
  id: string;
  content: GetFolderElementsFragment_elements_content;
}

export interface GetFolderElementsFragment {
  __typename: "Folder";
  elements: GetFolderElementsFragment_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GetKurssloeyfeElementsFragment
// ====================================================

export interface GetKurssloeyfeElementsFragment_elements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
}

export interface GetKurssloeyfeElementsFragment_elements {
  __typename: "KurssloeyfeElement";
  id: string;
  content: GetKurssloeyfeElementsFragment_elements_content;
}

export interface GetKurssloeyfeElementsFragment {
  __typename: "Kurssloeyfe";
  elements: GetKurssloeyfeElementsFragment_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NonRecursiveFolderContainerElementFragment
// ====================================================

export interface NonRecursiveFolderContainerElementFragment_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: NonRecursiveFolderContainerElementFragment_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: NonRecursiveFolderContainerElementFragment_FolderContainerFolderElement_content;
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_elements = NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement_content;
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface NonRecursiveFolderContainerElementFragment_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type NonRecursiveFolderContainerElementFragment = NonRecursiveFolderContainerElementFragment_FolderContainerFolderElement | NonRecursiveFolderContainerElementFragment_FolderContainerKurssloeyfeElement | NonRecursiveFolderContainerElementFragment_FolderContainerArticleElement | NonRecursiveFolderContainerElementFragment_FolderContainerMultipleChoiceElement;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FolderContainerWithoutFolderElementFragment
// ====================================================

export interface FolderContainerWithoutFolderElementFragment_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
}

export interface FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_elements = FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement_content;
}

export interface FolderContainerWithoutFolderElementFragment_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface FolderContainerWithoutFolderElementFragment_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type FolderContainerWithoutFolderElementFragment = FolderContainerWithoutFolderElementFragment_FolderContainerFolderElement | FolderContainerWithoutFolderElementFragment_FolderContainerKurssloeyfeElement | FolderContainerWithoutFolderElementFragment_FolderContainerArticleElement | FolderContainerWithoutFolderElementFragment_FolderContainerMultipleChoiceElement;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContainerFragment
// ====================================================

export interface ContainerFragment_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface ContainerFragment {
  __typename: "ExamSyllabusContainer" | "FolderContainer" | "KurssloeyfeContainer" | "StudyProgrammeContainer";
  title: string;
  referencedContentId: string;
  contentList: ContainerFragment_contentList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StudyProgrammeWithContainerContextsFragment
// ====================================================

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerFolderElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement {
  __typename: "StudyProgrammeContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerFolderElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerKurssloeyfeElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements_FolderContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_contentList[];
  type: FolderType | null;
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement {
  __typename: "FolderContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_contentList {
  __typename: "ContainerContent";
  contentId: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement {
  __typename: "KurssloeyfeContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement {
  __typename: "KurssloeyfeContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements_KurssloeyfeContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content {
  __typename: "KurssloeyfeContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_contentList[];
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement {
  __typename: "FolderContainerKurssloeyfeElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerArticleElement {
  __typename: "FolderContainerArticleElement";
  referencedContent: string;
  status: ContentStatus;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerMultipleChoiceElement {
  __typename: "FolderContainerMultipleChoiceElement";
  referencedContent: string;
  status: ContentStatus;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerFolderElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerKurssloeyfeElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerArticleElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements_FolderContainerMultipleChoiceElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content {
  __typename: "FolderContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_contentList[];
  type: FolderType | null;
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements {
  __typename: "ExamSyllabusContainerFolderElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements_content;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content {
  __typename: "ExamSyllabusContainer";
  title: string;
  referencedContentId: string;
  contentList: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_contentList[];
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement {
  __typename: "StudyProgrammeContainerExamSyllabusElement";
  content: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement_content;
}

export type StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements = StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerFolderElement | StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements_StudyProgrammeContainerExamSyllabusElement;

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer {
  __typename: "StudyProgrammeContainer";
  status: ContentStatus;
  title: string;
  referencedContentId: string;
  elements: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer_elements[];
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_examSyllabusContainerContexts {
  __typename: "ContainerContext";
  path: string;
  referencedContentId: string;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_folderContainerContexts {
  __typename: "ContainerContext";
  path: string;
  referencedContentId: string;
}

export interface StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers {
  __typename: "StudyProgrammeWithContainers";
  studyProgrammeContainer: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_studyProgrammeContainer;
  examSyllabusContainerContexts: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_examSyllabusContainerContexts[];
  folderContainerContexts: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers_folderContainerContexts[];
}

export interface StudyProgrammeWithContainerContextsFragment {
  __typename: "GetExamSyllabusContainerContextsPayload";
  studyProgrammesWithContainers: StudyProgrammeWithContainerContextsFragment_studyProgrammesWithContainers[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentElementIconFragment
// ====================================================

export interface ContentElementIconFragment_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
}

export interface ContentElementIconFragment_content_Article {
  __typename: "Article";
  youtubeVideoId: string | null;
}

export interface ContentElementIconFragment_content_Folder {
  __typename: "Folder";
  type: FolderType;
}

export type ContentElementIconFragment_content = ContentElementIconFragment_content_ExamSyllabus | ContentElementIconFragment_content_Article | ContentElementIconFragment_content_Folder;

export interface ContentElementIconFragment {
  __typename: "ExamSyllabusElement" | "FolderElement" | "KurssloeyfeElement" | "StudyProgrammeElement";
  content: ContentElementIconFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FeedbackMessageFragment
// ====================================================

export interface FeedbackMessageFragment_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface FeedbackMessageFragment_submittedBy {
  __typename: "User";
  id: string;
  fullName: string | null;
}

export interface FeedbackMessageFragment {
  __typename: "FeedbackMessage";
  id: string;
  removedAt: DateTime | null;
  body: FeedbackMessageFragment_body | null;
  /**
   * Nullable so we potentially can restrict the field from being shown.
   */
  submittedBy: FeedbackMessageFragment_submittedBy | null;
  submittedAt: DateTime;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentListFragment
// ====================================================

export interface ContentListFragment {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
  status: ContentStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GetFirstPublishedKurssloeyfeElementId
// ====================================================

export interface GetFirstPublishedKurssloeyfeElementId_elements_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  status: ContentStatus;
}

export interface GetFirstPublishedKurssloeyfeElementId_elements {
  __typename: "KurssloeyfeElement";
  id: string;
  content: GetFirstPublishedKurssloeyfeElementId_elements_content;
}

export interface GetFirstPublishedKurssloeyfeElementId {
  __typename: "Kurssloeyfe";
  elements: GetFirstPublishedKurssloeyfeElementId_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MultipleChoiceData
// ====================================================

export interface MultipleChoiceData_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface MultipleChoiceData_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceData_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceData_latestSubmitted {
  __typename: "MultipleChoiceAnswer";
  /**
   * From 0 to 1. 1 = 100%.
   */
  scoreInPercent: number | null;
  submittedAt: DateTime;
}

export interface MultipleChoiceData_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface MultipleChoiceData_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceData_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface MultipleChoiceData_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: MultipleChoiceData_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: MultipleChoiceData_questions_options[] | null;
}

export interface MultipleChoiceData_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface MultipleChoiceData_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface MultipleChoiceData {
  __typename: "MultipleChoice";
  id: string;
  type: MultipleChoiceType;
  title: string;
  context: MultipleChoiceData_context[];
  ingress: MultipleChoiceData_ingress | null;
  relevantContent: MultipleChoiceData_relevantContent | null;
  latestSubmitted: MultipleChoiceData_latestSubmitted | null;
  /**
   * used if the exercise is a grouping exercise
   */
  options: MultipleChoiceData_options[];
  questions: MultipleChoiceData_questions[];
  canUpdateDetails: MultipleChoiceData_canUpdateDetails;
  canCreateProgression: MultipleChoiceData_canCreateProgression;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentBreadcrumbFragment
// ====================================================

export interface ContentBreadcrumbFragment_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface ContentBreadcrumbFragment {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
  status: ContentStatus;
  context: ContentBreadcrumbFragment_context[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: KurssloeyfeElements
// ====================================================

export interface KurssloeyfeElements_elements_content_ExamSyllabus_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface KurssloeyfeElements_elements_content_ExamSyllabus {
  __typename: "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "StudyProgramme";
  id: string;
  status: ContentStatus;
  title: string;
  context: KurssloeyfeElements_elements_content_ExamSyllabus_context[];
}

export interface KurssloeyfeElements_elements_content_Article_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface KurssloeyfeElements_elements_content_Article_relevantContent {
  __typename: "MultilineText";
  content: string;
}

export interface KurssloeyfeElements_elements_content_Article_body {
  __typename: "MultilineText";
  isMarkdown: boolean;
  content: string;
}

export interface KurssloeyfeElements_elements_content_Article_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface KurssloeyfeElements_elements_content_Article {
  __typename: "Article";
  id: string;
  status: ContentStatus;
  title: string;
  context: KurssloeyfeElements_elements_content_Article_context[];
  youtubeVideoId: string | null;
  relevantContent: KurssloeyfeElements_elements_content_Article_relevantContent | null;
  body: KurssloeyfeElements_elements_content_Article_body | null;
  canCreateProgression: KurssloeyfeElements_elements_content_Article_canCreateProgression;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_ingress {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_relevantContent {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_latestSubmitted {
  __typename: "MultipleChoiceAnswer";
  /**
   * From 0 to 1. 1 = 100%.
   */
  scoreInPercent: number | null;
  submittedAt: DateTime;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: KurssloeyfeElements_elements_content_MultipleChoice_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: KurssloeyfeElements_elements_content_MultipleChoice_questions_options[] | null;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface KurssloeyfeElements_elements_content_MultipleChoice {
  __typename: "MultipleChoice";
  id: string;
  status: ContentStatus;
  title: string;
  context: KurssloeyfeElements_elements_content_MultipleChoice_context[];
  type: MultipleChoiceType;
  ingress: KurssloeyfeElements_elements_content_MultipleChoice_ingress | null;
  relevantContent: KurssloeyfeElements_elements_content_MultipleChoice_relevantContent | null;
  latestSubmitted: KurssloeyfeElements_elements_content_MultipleChoice_latestSubmitted | null;
  /**
   * used if the exercise is a grouping exercise
   */
  options: KurssloeyfeElements_elements_content_MultipleChoice_options[];
  questions: KurssloeyfeElements_elements_content_MultipleChoice_questions[];
  canUpdateDetails: KurssloeyfeElements_elements_content_MultipleChoice_canUpdateDetails;
  canCreateProgression: KurssloeyfeElements_elements_content_MultipleChoice_canCreateProgression;
}

export type KurssloeyfeElements_elements_content = KurssloeyfeElements_elements_content_ExamSyllabus | KurssloeyfeElements_elements_content_Article | KurssloeyfeElements_elements_content_MultipleChoice;

export interface KurssloeyfeElements_elements {
  __typename: "KurssloeyfeElement";
  finished: boolean;
  id: string;
  content: KurssloeyfeElements_elements_content;
}

export interface KurssloeyfeElements {
  __typename: "Kurssloeyfe";
  elements: KurssloeyfeElements_elements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SelfAssessmentFragment
// ====================================================

export interface SelfAssessmentFragment_articles_content_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface SelfAssessmentFragment_articles_content_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SelfAssessmentFragment_articles_content_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface SelfAssessmentFragment_articles_content_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface SelfAssessmentFragment_articles_content {
  __typename: "Article";
  id: string;
  title: string;
  status: ContentStatus;
  context: SelfAssessmentFragment_articles_content_context[];
  body: SelfAssessmentFragment_articles_content_body | null;
  youtubeVideoId: string | null;
  canUpdateDetails: SelfAssessmentFragment_articles_content_canUpdateDetails;
  canCreateProgression: SelfAssessmentFragment_articles_content_canCreateProgression;
}

export interface SelfAssessmentFragment_articles {
  __typename: "SelfAssessmentArticle";
  id: string;
  content: SelfAssessmentFragment_articles_content;
}

export interface SelfAssessmentFragment_multipleChoiceExercises_content_context {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface SelfAssessmentFragment_multipleChoiceExercises_content_canUpdateDetails {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface SelfAssessmentFragment_multipleChoiceExercises_content_canCreateProgression {
  __typename: "ActionAbility";
  canPerform: boolean;
}

export interface SelfAssessmentFragment_multipleChoiceExercises_content_questions_body {
  __typename: "MultilineText";
  content: string;
  isMarkdown: boolean;
}

export interface SelfAssessmentFragment_multipleChoiceExercises_content_questions_options {
  __typename: "MultipleChoiceQuestionOption";
  id: string;
  title: string;
  /**
   * Null if not authorized to know if it is correct.
   */
  correct: boolean | null;
}

export interface SelfAssessmentFragment_multipleChoiceExercises_content_questions {
  __typename: "MultipleChoiceQuestion";
  id: string;
  title: string;
  body: SelfAssessmentFragment_multipleChoiceExercises_content_questions_body | null;
  /**
   * Null if grouping exercise, because it unweils the answers
   */
  options: SelfAssessmentFragment_multipleChoiceExercises_content_questions_options[] | null;
}

export interface SelfAssessmentFragment_multipleChoiceExercises_content {
  __typename: "MultipleChoice";
  type: MultipleChoiceType;
  id: string;
  title: string;
  status: ContentStatus;
  context: SelfAssessmentFragment_multipleChoiceExercises_content_context[];
  canUpdateDetails: SelfAssessmentFragment_multipleChoiceExercises_content_canUpdateDetails;
  canCreateProgression: SelfAssessmentFragment_multipleChoiceExercises_content_canCreateProgression;
  questions: SelfAssessmentFragment_multipleChoiceExercises_content_questions[];
}

export interface SelfAssessmentFragment_multipleChoiceExercises {
  __typename: "SelfAssessmentMultipleChoiceExercise";
  id: string;
  content: SelfAssessmentFragment_multipleChoiceExercises_content;
}

export interface SelfAssessmentFragment_delivery_score {
  __typename: "Score";
  factorPercent: number;
}

export interface SelfAssessmentFragment_delivery {
  __typename: "SelfAssessmentDelivery";
  deliveredAt: DateTime;
  score: SelfAssessmentFragment_delivery_score;
}

export interface SelfAssessmentFragment {
  __typename: "SelfAssessment";
  id: string;
  title: string;
  originFolderId: string;
  originFolderParentId: string;
  status: SelfAssessmentStatus;
  articles: SelfAssessmentFragment_articles[];
  multipleChoiceExercises: SelfAssessmentFragment_multipleChoiceExercises[];
  delivery: SelfAssessmentFragment_delivery | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConsentStatusFragment
// ====================================================

export interface ConsentStatusFragment_basis {
  __typename: "ConsentBasis";
  id: string;
  title: string;
  type: ConsentType;
  purpose: string;
  validFrom: DateTime;
}

export interface ConsentStatusFragment {
  __typename: "UserConsent";
  isGiven: boolean;
  completed: boolean;
  basis: ConsentStatusFragment_basis;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GetStudyProgrammeElementIconFragment
// ====================================================

export interface GetStudyProgrammeElementIconFragment_content {
  __typename: "Article" | "ExamSyllabus" | "Folder" | "Kurssloeyfe" | "MultipleChoice" | "StudyProgramme";
  id: string;
  title: string;
}

export interface GetStudyProgrammeElementIconFragment {
  __typename: "StudyProgrammeElement";
  content: GetStudyProgrammeElementIconFragment_content;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ConsentType {
  PROGRESSION = "PROGRESSION",
  SAVE_SCORES = "SAVE_SCORES",
}

export enum ContentStatus {
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum FeedbackGivenOnType {
  FolderElement = "FolderElement",
  KurssloeyfeElement = "KurssloeyfeElement",
  SimulationCase = "SimulationCase",
}

export enum FolderType {
  GENERIC = "GENERIC",
  SELF_ASSESSMENT_EXERCISES = "SELF_ASSESSMENT_EXERCISES",
  SELF_ASSESSMENT_EXERCISES_CONTAINER = "SELF_ASSESSMENT_EXERCISES_CONTAINER",
}

export enum MultipleChoiceType {
  GROUPING = "GROUPING",
  STANDARD = "STANDARD",
}

export enum SelfAssessmentStatus {
  CANCELED = "CANCELED",
  DELIVERED = "DELIVERED",
  IN_PROGRESS = "IN_PROGRESS",
}

export interface AddFolderToExamSyllabusInput {
  examSyllabusId: string;
  folderIds: string[];
}

export interface ArticleInput {
  title: string;
  body?: MultilineTextInput | null;
  youtubeVideoId?: string | null;
}

export interface CancelSelfAssessmentInput {
  selfAssessmentId: string;
}

export interface ChatRequestMessageGQL {
  content?: string | null;
  role?: string | null;
}

export interface ChatRequestMessageInput {
  content: ChatRequestMessageGQL[];
  type?: string | null;
}

export interface ClinicalOutcomeInput {
  possibleOutcome?: string | null;
  isCorrectOutcome?: boolean | null;
}

export interface ClinicalTestInput {
  testName?: string | null;
  testResult?: MultilineTextInput | null;
}

export interface CopyContentInput {
  contentId: string;
  containerIds: string[];
}

export interface CreateArticleInFolderInput {
  folderId: string;
  article: ArticleInput;
}

export interface CreateArticleInKurssloeyfeInput {
  kurssloeyfeId: string;
  article: ArticleInput;
}

export interface CreateExamSyllabusInput {
  title: string;
  description: MultilineTextInput;
  studyPoints: number;
  examDate?: string | null;
  studyProgrammeId: string;
}

export interface CreateFeedbackResponseInput {
  id: string;
  body: MultilineTextInput;
}

export interface CreateFolderInput {
  parentId: string;
  type: FolderType;
  selfAssessmentExercisesFolderOptions?: SelfAssessmentExercisesFolderOptions | null;
  title: string;
  description?: MultilineTextInput | null;
}

export interface CreateKurssloeyfeInFolderInput {
  folderId: string;
  title: string;
}

export interface CreateMultipleChoiceInFolderInput {
  folderId: string;
  multipleChoice: MultipleChoiceInput;
}

export interface CreateMultipleChoiceInKurssloeyfeInput {
  kurssloeyfeId: string;
  multipleChoice: MultipleChoiceInput;
}

export interface CreateMultipleChoiceQuestionInput {
  multipleChoiceId: string;
  title: string;
  body?: MultilineTextInput | null;
  options: CreateMultipleChoiceQuestionInputOption[];
}

export interface CreateMultipleChoiceQuestionInputOption {
  title: string;
  correct: boolean;
}

export interface CreateMultipleChoiceQuestionOptionsInput {
  multipleChoiceId: string;
  questionId: string;
  options: MultipleChoiceQuestionOptionInput[];
}

export interface CreateSimulationCaseInput {
  simulationCaseInput?: SimulationCaseInput | null;
}

export interface CreateSimulationCaseOutlineInput {
  simulationCaseInput?: SimulationCaseOutlineInput | null;
}

export interface CreateStudentFeedbackInput {
  body: MultilineTextInput;
  givenOnReferenceId?: string | null;
  givenOnType?: FeedbackGivenOnType | null;
}

export interface CreateStudyProgrammeInput {
  title: string;
  description: MultilineTextInput;
  folderIds?: string[] | null;
}

export interface DeleteMultipleChoiceQuestionInput {
  multipleChoiceId: string;
  questionId: string;
}

export interface DeleteMultipleChoiceQuestionOptionInput {
  multipleChoiceId: string;
  questionId: string;
  optionId: string;
}

export interface DeliverSelfAssessmentInput {
  selfAssessmentId: string;
}

export interface FinishContentInput {
  contentId: string;
}

export interface GenerateUploadURLInput {
  bucket: string;
}

export interface GroupingCategoryAnswer {
  questionId: string;
  optionIds: string[];
}

export interface MoveContentInput {
  contentId: string;
  containerId: string;
}

export interface MultilineTextInput {
  content: string;
  isMarkdown: boolean;
}

export interface MultipleChoiceInput {
  title: string;
  type: MultipleChoiceType;
  ingress?: MultilineTextInput | null;
}

export interface MultipleChoiceQuestionOptionInput {
  title: string;
  correct: boolean;
}

export interface NextCaseInput {
  title?: string | null;
  id?: string | null;
}

export interface PublishAllContentInFolderInput {
  folderId: string;
}

export interface PublishAllContentInKurssloeyfeInput {
  kurssloeyfeId: string;
}

export interface ReferralInput {
  referralValue?: boolean | null;
  referralContent?: string | null;
}

export interface RemoveFeedbackMessageInput {
  feedbackId: string;
  messageId: string;
}

export interface RemoveFromS3Input {
  fileUrl: string;
  bucket: string;
}

export interface ReorderExamSyllabusElementInput {
  examSyllabusId: string;
  elementId: string;
  moveToAfterElementId?: string | null;
}

export interface ReorderFolderElementInput {
  folderId: string;
  elementId: string;
  moveToAfterElementId?: string | null;
}

export interface ReorderKurssloeyfeElementInput {
  kurssloeyfeId: string;
  elementId: string;
  moveToAfterElementId?: string | null;
}

export interface ReorderMultipleChoiceQuestionInput {
  multipleChoiceId: string;
  questionId: string;
  moveToAfterQuestionId?: string | null;
}

export interface ReorderMultipleChoiceQuestionOptionInput {
  multipleChoiceId: string;
  questionId: string;
  optionId: string;
  moveToAfterOptionId?: string | null;
}

export interface ReorderStudyProgrammeElementInput {
  studyProgrammeId: string;
  elementId: string;
  moveToAfterElementId?: string | null;
}

export interface SaveExamSyllabiForUserInput {
  studyProgrammeId: string;
  examSyllabiIds: string[];
}

export interface SaveStudyProgrammesForUserInput {
  studyProgrammeIds: string[];
}

export interface SelfAssessmentExercisesFolderOptions {
  numberOfExercisesToExtract: number;
}

export interface SimulationCaseCompletionMessageInput {
  content: ChatRequestMessageGQL[];
  type?: string | null;
  id: string;
}

export interface SimulationCaseInput {
  title: string;
  instantReferral?: ReferralInput | null;
  diagnosis?: (ClinicalOutcomeInput | null)[] | null;
  treatment?: (ClinicalOutcomeInput | null)[] | null;
  referral?: (ClinicalOutcomeInput | null)[] | null;
  patientInformation?: MultilineTextInput | null;
  assessments?: (ClinicalTestInput | null)[] | null;
  status: ContentStatus;
  module: string;
  difficulty: string;
  clinicalCategory: string;
  nextCase?: NextCaseInput | null;
}

export interface SimulationCaseOutlineInput {
  title: string;
  patientInformation: MultilineTextInput;
  status: ContentStatus;
  module: string;
  difficulty: string;
  clinicalCategory: string;
}

export interface StartSelfAssessmentInput {
  selfAssessmentExercisesFolderId: string;
}

export interface UpdateArticleDetailsInput {
  id: string;
  status?: UpdateContentStatusRequiredInput | null;
  title?: UpdateStringRequiredInput | null;
  body?: UpdateMultilineTextOptionalInput | null;
  relevantContent?: UpdateMultilineTextOptionalInput | null;
  youtubeVideoId?: UpdateStringOptionalInput | null;
}

export interface UpdateContentStatusInput {
  id: string;
  status: UpdateContentStatusRequiredInput;
}

export interface UpdateContentStatusRequiredInput {
  updatedValue?: ContentStatus | null;
}

export interface UpdateDoubleRequiredInput {
  updatedValue: number;
}

export interface UpdateExamSyllabusDetailsInput {
  id: string;
  status?: UpdateContentStatusRequiredInput | null;
  title?: UpdateStringRequiredInput | null;
  description?: UpdateMultilineTextRequiredInput | null;
  examDate?: UpdateStringRequiredInput | null;
  studyPoints?: UpdateDoubleRequiredInput | null;
}

export interface UpdateFolderDetailsInput {
  id: string;
  status?: UpdateContentStatusRequiredInput | null;
  title?: UpdateStringRequiredInput | null;
  description?: UpdateMultilineTextOptionalInput | null;
}

export interface UpdateKurssloeyfeDetailsInput {
  id: string;
  status?: UpdateContentStatusRequiredInput | null;
  title?: UpdateStringRequiredInput | null;
}

export interface UpdateMultilineTextOptionalInput {
  updatedValue?: MultilineTextInput | null;
}

export interface UpdateMultilineTextRequiredInput {
  updatedValue: MultilineTextInput;
}

export interface UpdateMultipleChoiceDetailsInput {
  id: string;
  status?: UpdateContentStatusRequiredInput | null;
  title?: UpdateStringRequiredInput | null;
  ingress?: UpdateMultilineTextOptionalInput | null;
  relevantContent?: UpdateMultilineTextOptionalInput | null;
}

export interface UpdateMultipleChoiceQuestionDetailsInput {
  multipleChoiceId: string;
  multipleChoiceQuestionId: string;
  title?: UpdateStringRequiredInput | null;
  body?: UpdateMultilineTextOptionalInput | null;
}

export interface UpdateMultipleChoiceQuestionOptionInput {
  multipleChoiceId: string;
  questionId: string;
  optionId: string;
  title?: UpdateStringRequiredInput | null;
  correct?: boolean | null;
}

export interface UpdateSimulationCaseInput {
  id: string;
  simulationCaseInput?: SimulationCaseInput | null;
}

export interface UpdateStringOptionalInput {
  updatedValue?: string | null;
}

export interface UpdateStringRequiredInput {
  updatedValue: string;
}

export interface UpdateStudyProgrammeDetailsInput {
  id: string;
  status?: UpdateContentStatusRequiredInput | null;
  title?: UpdateStringRequiredInput | null;
  description?: UpdateMultilineTextRequiredInput | null;
  folderIds?: string[] | null;
}

export interface UpdateUserConsentInput {
  consentId: string;
  isGiven: boolean;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
